
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gHXqX", function(module, exports) {
$parcel$export(module.exports, "LoggedOutOrNoJiraProductTourOverview", function () { return $9c557963d1338261$export$94dc3fb7b045f547; });
/* jira-software-logged-out-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $kbpa7 = parcelRequire("kbpa7");

var $l4vdU = parcelRequire("l4vdU");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $5S2vX = parcelRequire("5S2vX");

var $8IN8s = parcelRequire("8IN8s");

var $iKNCS = parcelRequire("iKNCS");

var $Tm4Gw = parcelRequire("Tm4Gw");

var $73ThH = parcelRequire("73ThH");

var $4AJjX = parcelRequire("4AJjX");

var $ihq7I = parcelRequire("ihq7I");

var $iFk4q = parcelRequire("iFk4q");

var $fCRLS = parcelRequire("fCRLS");

var $bRgjW = parcelRequire("bRgjW");

var $dS67T = parcelRequire("dS67T");

var $1UnBI = parcelRequire("1UnBI");

var $1i0Tw = parcelRequire("1i0Tw");

var $6PlQY = parcelRequire("6PlQY");
const $9c557963d1338261$export$94dc3fb7b045f547 = ()=>{
    const isLoggedOut = (0, $2WL8B.useLoggedOut)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind6469FrictionlessFirstLookJiraV3);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    let heroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1i0Tw.NoJiraHeroSection), {});
    if (isLoggedOut) heroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1UnBI.LoggedOutHeroSection), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "logged-out-no-jira-product-tour",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Tm4Gw.JiraSoftwarePageBannerAlert), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                "data-testid": "loggedOutNoJira",
                id: "content",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "Jira",
                    children: [
                        heroSection,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $73ThH.GartnerSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bRgjW.JswCollaborateSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iKNCS.AiRefreshSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4AJjX.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dS67T.JswDoubleFeatureSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fCRLS.IntegrationsSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk17la"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6PlQY.TestimonialSection), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihq7I.ClosingBanner), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iFk4q.Footer), {})
                    ]
                })
            })
        ]
    });
};
const $9c557963d1338261$var$sectionContainerStyles = null;
const $9c557963d1338261$var$backgroundStyles = null;

});
parcelRegister("iKNCS", function(module, exports) {
$parcel$export(module.exports, "AiRefreshSection", function () { return $b7205ca5f6b32aa0$export$53cedacbbc185d7; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f11bi = parcelRequire("f11bi");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $kgXas = parcelRequire("kgXas");

var $b3ukl = parcelRequire("b3ukl");

var $hLTRc = parcelRequire("hLTRc");
const $b7205ca5f6b32aa0$export$53cedacbbc185d7 = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    if (useGWP7617Gate) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $b3ukl.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.eyebrow",
            defaultMessage: "Plan, Track, and Collaborate"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.heading",
            defaultMessage: "Where your team + AI come together"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.description",
            defaultMessage: "Jira\u2019s AI helps teams drive better outcomes, faster."
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                video: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/374p64xck763gywok4l212n24sji512r.mp4",
                    controls: false,
                    autoplay: true,
                    muted: true,
                    loop: true,
                    width: 1300,
                    height: 694
                },
                Icon: (0, $hLTRc.TimelineIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card1.Title",
                    defaultMessage: "Jumpstart planning"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card1.Description",
                    defaultMessage: "Create work items from your favorite tools, then use AI to break down big ideas, polish descriptions, and link relevant resources in a snap."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/workflow-builder.webp",
                        alt: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card2.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: (0, $hLTRc.RedoIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card2.Title",
                    defaultMessage: "Focus on impact"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card2.Description",
                    defaultMessage: "Cut down on admin with AI agents that make it easier to create project plans, identify trends, and flag potential risks."
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card2.LinkText",
                            defaultMessage: "Meet Rovo agents"
                        }),
                        href: "/software/rovo/use-cases?feature=agent&"
                    }
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/linked-work-items.webp",
                        alt: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card3.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: (0, $hLTRc.FastIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card3.Title",
                    defaultMessage: "Stay in sync"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card3.Description",
                    defaultMessage: "Surface related work, summarize lengthy comments, and connect work to company goals to give your team the details they need to work faster and make better decisions."
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card3.LinkText",
                            defaultMessage: "Explore AI features"
                        }),
                        href: "/software/jira/ai"
                    }
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kgXas.Ai), {});
};

});
parcelRegister("kgXas", function(module, exports) {
$parcel$export(module.exports, "Ai", function () { return $f3edea71192b0806$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $iNnWi = parcelRequire("iNnWi");

var $1pbCD = parcelRequire("1pbCD");
const $f3edea71192b0806$export$7ae07b56aa46260e = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const title = formatMessage({
        id: "jira-product-tour.ai-section.title-text",
        defaultMessage: "Your next move, suggested by AI"
    });
    const subTitle = formatMessage({
        id: "jira-product-tour.ai-section.subtitle-text",
        defaultMessage: "Atlassian Intelligence takes your big ideas and automatically suggests the tasks to help get it done."
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.ai-section.button-text",
        defaultMessage: "Explore Atlassian Intelligence"
    });
    const videoLink = (0, $iNnWi.getAiVideo)(locale);
    const imageLink = (0, $iNnWi.getAiImage)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-ai-button-clicked",
                section: "ai-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _6a6z1h6o _bfhk17la _syazu67f _ca0qvbgk _u5f39by0 _n3tdvbgk _19bv9by0 _zulpzwfg"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pbCD.Intelligence), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_1wybckbl _k48p1fw0 _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syazcd5j _y3gn1h6o _ect4bzd7 _1wyb7vkz _k48p1nn1"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1tz91y44 _1k797vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "secondary",
                            color: "white",
                            colorAgainst: "other",
                            size: "large",
                            href: (0, $jQ0cd.useLocalizedHref)("/software/jira/ai"),
                            onClick: handleClick,
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "explore-atlassian-intelligence",
                                "data-label-english": `${buttonText}`,
                                "data-track-event": "jira-pt.ai-section.explore-atlassian-intelligence"
                            },
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        autoPlay: true,
                        loop: true,
                        controls: true,
                        className: (0, $2jatx.default)([
                            "_p12f1uof _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19451ogm _liwcglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: imageLink,
                            alt: "",
                            width: 2752,
                            height: 1838
                        },
                        className: (0, $2jatx.default)([
                            "_mezj1osq _bna71wug _14bq7vkz _3tce7vkz _1ym67vkz _1xr17vkz _1z4kglyw"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tkemgvx _12vemgnk _ouxlbbky _1lrwykpt _1itkoro1 _1jgo1wqb _1w8u1dh4"
                ])
            })
        ]
    });
};
const $f3edea71192b0806$var$aiSectionStyles = null;
const $f3edea71192b0806$var$imageStyles = null;
const $f3edea71192b0806$var$videoStyles = null;
const $f3edea71192b0806$var$titleStyles = null;
const $f3edea71192b0806$var$subTitleStyles = null;
const $f3edea71192b0806$var$buttonStyles = null;
const $f3edea71192b0806$var$footerStyles = null;

});


parcelRegister("Tm4Gw", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageBannerAlert", function () { return $581896a3442fe3b7$export$5f2661a957aa01ba; });

var $7VQPk = parcelRequire("7VQPk");

var $k3xrk = parcelRequire("k3xrk");
const $581896a3442fe3b7$export$5f2661a957aa01ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k3xrk.GWP8238AcquisitionBanner), {
        productKey: "jiraSoftware",
        identifier: "JiraSoftwarePageTemplate.banner.gwp-8238-announcement",
        ufoSegmentName: "jira-software-bannerAlert-gwp8238",
        testId: "gwp-8238-announcement-jira",
        linkTextId: "JiraSoftwarePage.banner-alert.gwp-8238-announcement.link-text",
        linkTextDefault: "Learn more"
    });
};

});
parcelRegister("k3xrk", function(module, exports) {
$parcel$export(module.exports, "GWP8238AcquisitionBanner", function () { return $8c4f05102dffb3c9$export$21516a4ccbdd4e52; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $iRMRa = parcelRequire("iRMRa");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $dEFIL = parcelRequire("dEFIL");
const $8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BannerAlert.gwp-8238-announcement.event-details",
        defaultMessage: "<strong>Breaking news:</strong> DX to join Atlassian!",
        values: (0, $iRMRa.DEFAULT_VALUES)
    });
const $8c4f05102dffb3c9$export$21516a4ccbdd4e52 = ({ productKey: productKey, identifier: identifier, ufoSegmentName: ufoSegmentName, testId: testId, linkTextId: linkTextId = "BannerAlert.gwp-8238-announcement.link-text", linkTextDefault: linkTextDefault = "Learn more" })=>{
    const intl = (0, $8e22h.default)();
    if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8238BannerAnnouncement)) return null;
    const linkText = intl.formatMessage({
        id: linkTextId,
        defaultMessage: linkTextDefault
    });
    const acquisitionAnnouncementConfig = {
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        imageMobileProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        identifier: identifier,
        text: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)($8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail, {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "data-testid": testId
                })
            ]
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)($8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail, {}),
        productKey: productKey,
        backgroundPreset: "gwp-8238-announcement",
        linkText: linkText,
        linkUrl: "https://www.atlassian.com/blog/announcements/atlassian-acquires-dx",
        dataEventProps: {
            "data-product-key": productKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": linkText,
            "data-label-english": "Learn more"
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: ufoSegmentName,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), {
            ...acquisitionAnnouncementConfig
        })
    });
};

});


parcelRegister("73ThH", function(module, exports) {
$parcel$export(module.exports, "GartnerSection", function () { return $b4828e26cb60559a$export$4c6bc3f3981e1f4c; });
/* gartner-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $b4828e26cb60559a$var$GartnerStyles = null;
const $b4828e26cb60559a$export$4c6bc3f3981e1f4c = ({ experimentEnabled: experimentEnabled })=>{
    const getGwp4948GartnerJiraProductTourExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp4948GartnerJiraProductTourExperiment);
    const gwp4948GartnerJiraProductTourExperimentIsActive = experimentEnabled || getGwp4948GartnerJiraProductTourExperiment !== undefined && getGwp4948GartnerJiraProductTourExperiment.type === "enrolled" && getGwp4948GartnerJiraProductTourExperiment.value === "test";
    const intl = (0, $8e22h.default)();
    const gartnerImage = // eslint-disable-next-line local/no-non-orangelogic-images-eslint
    "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner-jsw-left-img.webp";
    const gartnerMarketingHref = (0, $jQ0cd.useLocalizedHref)("https://www.atlassian.com/gartner/magic-quadrant-marketing-work-management");
    const gartnerDevopsHref = (0, $jQ0cd.useLocalizedHref)("https://www.atlassian.com/gartner/magic-quadrant-devops");
    const gartnerMarketingLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: gartnerMarketingHref,
            children: children
        });
    const gartnerDevopsLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: gartnerDevopsHref,
            children: children
        });
    if (gwp4948GartnerJiraProductTourExperimentIsActive) return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _vwz410nf _1bah1h6o _ca0q53f4 _u5f3idpf _n3td12am _19bvidpf _1pfhkgzx _1itk1a3y _43ds17la _11eb8pqr _d62sidpf _dubxo1fv"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: gartnerImage,
                        alt: ""
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.GartnerSection.header",
                                defaultMessage: "Atlassian named a Leader in the 2024 Gartner\xae Magic Quadrant"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraSoftwarePageTemplate.GartnerSection.body",
                            defaultMessage: `The best work management solution for all teams \u{2014} Atlassian is the only platform to be recognized as a Leader for both <gartnerMarketingLink>Marketing</gartnerMarketingLink> and <gartnerDevopsLink>DevOps</gartnerDevopsLink>`,
                            values: {
                                gartnerMarketingLink: gartnerMarketingLink,
                                gartnerDevopsLink: gartnerDevopsLink
                            }
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};

});

parcelRegister("4AJjX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f8bab4e5d7d8552$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eO8Mp = parcelRequire("eO8Mp");

var $iNnWi = parcelRequire("iNnWi");
const $5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const tailoredHeadingText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.header-text-gwp-7617",
        defaultMessage: "Tailor for your team"
    }) : intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-header-text",
        defaultMessage: "Tailor it for your team"
    });
    const tailoredBodyText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text-gwp-7617",
        defaultMessage: "Customize Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done. "
    }) : intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text",
        defaultMessage: "Configure Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done."
    });
    const tailoredLinkNew = (0, $jQ0cd.useLocalizedHref)("/software/jira/guides/getting-started/basics#step-3-set-up-your-columns");
    const tailoredLinkOld = (0, $jQ0cd.useLocalizedHref)("/software/jira/guides/issues/overview#what-is-an-issue");
    const tailoredLink = useGWP7617Gate ? tailoredLinkNew : tailoredLinkOld;
    const featureData = [
        {
            headingText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-header-text",
                defaultMessage: "Everything in one place"
            }),
            bodyText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-body-text",
                defaultMessage: "The context you need, when you need it. See software team release dates, real-time views of Figma designs, and more, all inside Jira."
            }),
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                defaultMessage: "Explore features"
            }),
            linkUrl: (0, $jQ0cd.useLocalizedHref)("/software/jira/features"),
            imageLink: (0, $iNnWi.getStaggeredDoubleFeautureFirstImage)(intl.locale),
            analyticsEventLabel: "atlas-55799-jira-features-button-clicked",
            imageHeight: 440
        },
        {
            headingText: tailoredHeadingText,
            bodyText: tailoredBodyText,
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-link-text",
                defaultMessage: "Learn more"
            }),
            linkUrl: tailoredLink,
            imageLink: (0, $iNnWi.getStaggeredDoubleFeautureSecondImage)(intl.locale),
            analyticsEventLabel: "atlas-55799-jira-issues-button-clicked",
            imageHeight: 490
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eO8Mp.StaggeredFeatureList), {
        mainHeadingText: intl.formatMessage({
            id: "jira-product-tour.staggered-double-feature-section.header-text",
            defaultMessage: "Bring every team together under one roof"
        }),
        subHeadingText: intl.formatMessage({
            id: "jira-product-tour.staggered-double-feature-section.subheader-text",
            defaultMessage: "Spend less time trying to get aligned and more time driving projects forward with confidence."
        }),
        featureData: featureData,
        startingImagePosition: "left"
    });
};
$5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection.displayName = "BuildAndSupportDoubleFeatureSection";
var $5f8bab4e5d7d8552$export$2e2bcd8739ae039 = $5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection;

});
parcelRegister("eO8Mp", function(module, exports) {
$parcel$export(module.exports, "StaggeredFeatureList", function () { return $9992b1ac5c0075b5$export$5bd229e30bf4ab20; });
/* staggered-feature-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $2lwXu = parcelRequire("2lwXu");
const $9992b1ac5c0075b5$var$containerStyle = null;
const $9992b1ac5c0075b5$var$mainHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$subHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$featureContainerStyle = null;
const $9992b1ac5c0075b5$var$featureImageContainerStyle = null;
const $9992b1ac5c0075b5$var$featureBodyContainerStyle = null;
const $9992b1ac5c0075b5$var$featureLinkStyles = null;
const $9992b1ac5c0075b5$var$featureHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$featureBodyTextStyle = null;
const $9992b1ac5c0075b5$var$Feature = ({ featureData: featureData, imagePosition: imagePosition })=>{
    if (imagePosition === "left") return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureImage, {
                ...featureData
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureBody, {
                ...featureData
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureBody, {
                ...featureData
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureImage, {
                ...featureData
            })
        ]
    });
};
const $9992b1ac5c0075b5$var$FeatureImage = ({ imageLink: imageLink, imageHeight: imageHeight })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1tvckb7n _1rwy1tcg _1y8o1ogm _bna71ns9 _rtys1ogm _1lre1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: imageLink,
                alt: "",
                width: 600,
                height: imageHeight
            }
        })
    });
};
const $9992b1ac5c0075b5$var$FeatureBody = ({ headingText: headingText, bodyText: bodyText, linkUrl: linkUrl, linkText: linkText, analyticsEventLabel: analyticsEventLabel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `${analyticsEventLabel}`,
                section: "staggered-feature-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1o9zgrho _4cvr1h6o _1pfhvrzy _1bsb1diq _zulpftgi _1tvccs5v _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _ect41pz4 _k48p1fw0 _vwz410mc _slp31hna _195gidpf _1mouidpf _y3gn1h6o"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _ect4bzd7 _k48p1nn1 _vwz41gkc _slp31hna _y3gn1h6o _p12fng7t _ca0qidpf _u5f310yn _n3tdidpf _19bv10yn _1y8o1osq"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                href: linkUrl,
                onClick: handleClick,
                "aria-label": formatMessage({
                    id: "learnMoreAbout",
                    defaultMessage: "Learn more about {subject}"
                }, {
                    subject: headingText
                }),
                className: (0, $2jatx.default)([
                    "_syaz17la"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: [
                    linkText,
                    " ",
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lwXu.ArrowRightNoCircle), {})
                ]
            })
        ]
    });
};
const $9992b1ac5c0075b5$export$5bd229e30bf4ab20 = ({ mainHeadingText: mainHeadingText, subHeadingText: subHeadingText, featureData: featureData, startingImagePosition: startingImagePosition })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1mou16xz _195gidpf _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _91qc9by0 _1x7014no"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect41pz4 _1wybckbl _zg8l4jg8 _k48p1fw0 _slp31hna _flz0zwfg _1lzozwfg _1cqs1ul9"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: mainHeadingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _1pfh7vkz _1bsbbxu3 _79ty1bp4 _1np61h6o _1rwy1tcg _7se29by0 _zzrm1osq _s637jwe6"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: subHeadingText
            }),
            featureData.map((feature, index)=>index % 2 === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$Feature, {
                    imagePosition: startingImagePosition === "left" ? "left" : "right",
                    featureData: feature
                }, index) : /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$Feature, {
                    imagePosition: startingImagePosition === "left" ? "right" : "left",
                    featureData: feature
                }, index))
        ]
    });
};

});
parcelRegister("2lwXu", function(module, exports) {
$parcel$export(module.exports, "ArrowRightNoCircle", function () { return $bbe047a4ec4aed29$export$c6abe79c9e2193ff; });

var $7VQPk = parcelRequire("7VQPk");
const $bbe047a4ec4aed29$export$c6abe79c9e2193ff = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});



parcelRegister("ihq7I", function(module, exports) {
$parcel$export(module.exports, "ClosingBanner", function () { return $683d4f00c3f6f587$export$3c134be78c4f7e1c; });
/* closing-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $683d4f00c3f6f587$export$3c134be78c4f7e1c = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const text = useGWP7617Gate ? formatMessage({
        id: "jira-product-tour.closing-banner.header-text-gwp-7617",
        defaultMessage: "No matter what you dream up, Jira helps you get it done."
    }) : formatMessage({
        id: "jira-product-tour.closing-banner.header-text",
        defaultMessage: "No matter what you're trying to dream up, Jira helps you get it done"
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.closing-banner.button-text",
        defaultMessage: "Get Jira free"
    });
    const ctaButtonUrl = "/try/cloud/signup?bundle=jira-software";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1b1v _4cvr1h6o _p12f1dho _19pkidpf _2hwx1wug _otyridpf _18u01wug _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1gde1bp4 _nssp1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _zulp1ylp _144t1wqb _zzsz1h6o _1tz91y44"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_p12fntfb _ect41pz4 _k48p1fw0 _1wyb1ylp _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazcd5j _xsmr1h6o _1cqs1ul9 _1bys14no"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: text
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                        intentType: "button",
                        containerId: "jira-product-tour-overview-closing-banner",
                        productKey: "jira-software.ondemand",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "primary",
                            size: "small",
                            color: "yellow",
                            href: (0, $jQ0cd.useLocalizedHref)(ctaButtonUrl),
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "get-jira-free",
                                "data-label-english": `${buttonText}`,
                                "data-track-event": "jira-pt.closing-banner.get-jira-free"
                            },
                            children: buttonText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1bsbhvew _4t3ieq5r _1wpzh9n0 _1wn41h6o _1tvd1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_mezjhvew _bna7eq5r"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/865y3n8f2i1843j2vs45535l48vtx77r.webp",
                                alt: "",
                                width: 303,
                                height: 303
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152t1skh _1e021wqb"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xbvh6b7g0mjibasf143rj6711054m0cf.webp",
                                alt: "",
                                width: 95,
                                height: 97
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$683d4f00c3f6f587$export$3c134be78c4f7e1c.displayName = "ClosingBanner";
const $683d4f00c3f6f587$var$ctaBannerContainer = null;
const $683d4f00c3f6f587$var$contentContainer = null;
const $683d4f00c3f6f587$var$headerStyles = null;
const $683d4f00c3f6f587$var$imageContainer = null;
const $683d4f00c3f6f587$var$imageStyles = null;
const $683d4f00c3f6f587$var$overlayStarImage = null;

});

parcelRegister("iFk4q", function(module, exports) {
$parcel$export(module.exports, "Footer", function () { return $f4806120b6b5d670$export$a06f1c675e846f6f; });

var $7VQPk = parcelRequire("7VQPk");

var $iLjCW = parcelRequire("iLjCW");
const $f4806120b6b5d670$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
    });
};
$f4806120b6b5d670$export$a06f1c675e846f6f.displayName = "Footer";

});

parcelRegister("fCRLS", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSection", function () { return $adef94d25ceb314a$export$94c8b142f0acfaff; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kVWxs = parcelRequire("kVWxs");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $adef94d25ceb314a$export$94c8b142f0acfaff = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // TODO: add width and height prop to iconData to use in Picture component
    const iconData = [
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/n773sikm845802hme5xs1ne04uy2g837.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.microsoft-alt-text",
                defaultMessage: "Microsoft Teams icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2b5621s46n36ogarwic4734b30xge4b.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-drive-alt-text",
                defaultMessage: "Google Drive icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/wrb81j78p4733kc10bdjw8v637h1w438.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-doc-alt-text",
                defaultMessage: "Google Docs icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/1m0x1742g31t1446203avy1kpi468me1.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.figma-alt-text",
                defaultMessage: "Figma icon"
            }),
            width: 48,
            height: 60
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2035t28j8p045avd6kjvjpr68g0uyfb.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.miro-alt-text",
                defaultMessage: "Miro icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/ow67lf57t0be1t6ami55288g1dx2kp46.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.slack-alt-text",
                defaultMessage: "Slack icon"
            }),
            width: 60,
            height: 58
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/uje2jom52scmv5bs8o1ej15sp162l6h0.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.zoom-alt-text",
                defaultMessage: "Zoom icon"
            }),
            width: 60,
            height: 13
        }
    ];
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-integrations-button-clicked",
                section: "integration-section"
            }
        }).fire();
    };
    const headingText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.integrations-section.heading-text-gwp-7617",
        defaultMessage: "Meet teams where they work"
    }) : intl.formatMessage({
        id: "jira-product-tour.integrations-section.heading-text",
        defaultMessage: "Meets teams where they work"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kVWxs.OffsetIconCollection), {
        headingText: headingText,
        bodyText: intl.formatMessage({
            id: "jira-product-tour.integrations-section.body-text",
            defaultMessage: "If your team uses it, we integrate with it. Easily add your favorite tools from the Atlassian Marketplace, keeping Jira as your central source of truth."
        }),
        iconData: iconData,
        ctaText: intl.formatMessage({
            id: "jira-product-tour.integrations-section.cta-text",
            defaultMessage: "Go to Marketplace"
        }),
        ctaLink: "https://marketplace.atlassian.com",
        ctaOnClickFunc: handleClick
    });
};
$adef94d25ceb314a$export$94c8b142f0acfaff.displayName = "IntegrationsSection";

});
parcelRegister("kVWxs", function(module, exports) {
$parcel$export(module.exports, "OffsetIconCollection", function () { return $bef0e19d7a97ecea$export$87daf6ae3676874; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $hnmMQ = parcelRequire("hnmMQ");
const $bef0e19d7a97ecea$var$sectionContainer = null;
const $bef0e19d7a97ecea$var$contentContainer = null;
const $bef0e19d7a97ecea$var$textContainerStyles = null;
const $bef0e19d7a97ecea$var$headingTextStyles = null;
const $bef0e19d7a97ecea$var$ctaStyles = null;
const $bef0e19d7a97ecea$var$iconContainerStyles = null;
const $bef0e19d7a97ecea$var$iconPictureStyles = null;
const $bef0e19d7a97ecea$var$animationStyle = null;
const $bef0e19d7a97ecea$export$4b1f681ca613adbb = ({ src: src, alt: alt, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: src,
            alt: alt,
            width: width,
            height: height
        }
    });
};
const $bef0e19d7a97ecea$export$87daf6ae3676874 = ({ iconData: iconData, headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _bfhk1hxd _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _1pbykb7n _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mou1qr7 _liwc1txw _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1x701ylp"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulp1ul9 _4cvr1y6m _syazqlpt _bozg1ul9 _m80d1h6o _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_k48p1fw0 _1wyb1wto _vwz4cjiy _1mouidpf _1r3wl07h"
                            ]),
                            children: headingText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: ctaLink,
                            onClick: ctaOnClickFunc,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_11q7glyw _1wyb1k92 _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _ect41kw7 _19it1axk _80omtlke"
                                ]),
                                children: ctaText
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: scrollRef,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp1wyk _1bah1h6o _ae4v1h6o _p12f18a8 _1o9zidpf _zzrm1kdj _1rwy1ylp"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            style: {
                                animationDelay: `${0.5 + 0.25 * index}s`
                            },
                            className: (0, $2jatx.default)([
                                "_2rko1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _bfhku67f _1bsb53f4 _4t3i53f4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _vavro7ao _zzrmvbgk _1gdlvbgk _60iy1txw _2a1o1h6o _1biz1h6o _137x8tad _mgbt1343 _v1631fm0 _1vsm1fm0 _1v3g1fm0 _1vvw1fm0 _rtys1osq _19l31osq _mezj1wug _bna71wug",
                                sectionIsVisible && "_j7hq1nm9"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($bef0e19d7a97ecea$export$4b1f681ca613adbb, {
                                src: icon.url,
                                alt: icon.altText,
                                width: icon.width,
                                height: icon.height
                            })
                        }, index))
                })
            ]
        })
    });
};

});


parcelRegister("bRgjW", function(module, exports) {
$parcel$export(module.exports, "JswCollaborateSection", function () { return $0461ddbaa879edb2$export$46dbd2229fc0687f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iNnWi = parcelRequire("iNnWi");

var $h5cWZ = parcelRequire("h5cWZ");
const $0461ddbaa879edb2$export$46dbd2229fc0687f = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // first item
    const firstFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.first-feature-description-text",
        defaultMessage: "From short projects, to large cross-functional programs, Jira helps break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
    });
    const firstFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.first-feature-description-text-ai",
        defaultMessage: "From short projects, to large cross-functional programs, Jira uses AI to help break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
    });
    // third item
    const thirdFeatureTitleOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-title-text",
        defaultMessage: "Track work your way"
    });
    const thirdFeatureTitleAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-title-text-ai",
        defaultMessage: "Work your way"
    });
    const thirdFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-description-text",
        defaultMessage: "Visualize work with lists, boards, backlogs, and more. Make workflows for any process and integrate with tools you love."
    });
    const thirdFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-description-text-ai",
        defaultMessage: "Keep Jira in sync with your favorite tools, customize your workflows with AI \u2013 and, stay on top of it all with lists, boards, and timeline views."
    });
    // fourth item
    const fourthFeatureTitleOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-title-text",
        defaultMessage: "Optimize with insights"
    });
    const fourthFeatureTitleAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-title-text-ai",
        defaultMessage: "Keep your projects on track"
    });
    const fourthFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-description-text",
        defaultMessage: "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
    });
    const fourthFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-description-text-ai",
        defaultMessage: "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
    });
    const options = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.first-feature-title-text",
                defaultMessage: "\u26A1 Plan and organize tasks"
            }),
            image: (0, $iNnWi.getCollaborateFirstImage)(intl.locale),
            description: useGWP7617Gate ? firstFeatureDescriptionAI : firstFeatureDescriptionOld
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-title-text",
                defaultMessage: "Align work to goals"
            }),
            image: (0, $iNnWi.getCollaborateSecondImage)(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-description-text",
                defaultMessage: "Link work to goals so everyone can see how their work contributes to company objectives and stay aligned to what\u2019s important."
            })
        },
        {
            title: useGWP7617Gate ? thirdFeatureTitleAI : thirdFeatureTitleOld,
            image: (0, $iNnWi.getCollaborateThirdImage)(intl.locale),
            description: useGWP7617Gate ? thirdFeatureDescriptionAI : thirdFeatureDescriptionOld
        },
        {
            title: useGWP7617Gate ? fourthFeatureTitleAI : fourthFeatureTitleOld,
            image: (0, $iNnWi.getCollaborateFourthImage)(intl.locale),
            description: useGWP7617Gate ? fourthFeatureDescriptionAI : fourthFeatureDescriptionOld
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h5cWZ.JswCollaborate), {
        options: options,
        heading: intl.formatMessage({
            id: "jira-product-tour.collaborate-section.title-text",
            defaultMessage: "Made for complex projects or everyday tasks"
        })
    });
};
$0461ddbaa879edb2$export$46dbd2229fc0687f.displayName = "JswCollaborateSection";

});
parcelRegister("h5cWZ", function(module, exports) {
$parcel$export(module.exports, "JswCollaborate", function () { return $b8e4fdbb89836c28$export$b0665de8e27040dd; });
/* jsw-collaborate.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $b8e4fdbb89836c28$export$b0665de8e27040dd = ({ heading: heading, options: options })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const [activeOption, setActiveOption] = (0, $1oC0p.useState)(0);
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const changeActive = (index)=>{
        // Cancel all animations before activeOption change
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === "progressgrow";
        });
        progressGrowAnimations.forEach((animation)=>{
            animation.cancel();
        });
        setActiveOption(index);
    };
    (0, $1oC0p.useEffect)(()=>{
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === "progressgrow";
        });
        // set finish event
        progressGrowAnimations.forEach((animation)=>{
            animation.onfinish = ()=>{
                setActiveOption(activeOption == options.length - 1 ? 0 : activeOption + 1);
                animation.cancel();
            };
        });
        // Only cycle when visible
        if (!sectionIsVisible) progressGrowAnimations.forEach((animation)=>{
            animation.pause();
        });
        else progressGrowAnimations.forEach((animation)=>{
            animation.play();
        });
    }, [
        activeOption,
        options.length,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o _1rjc12am _195gzwfg _1ilvzwfg _91qcidpf",
            sectionIsVisible ? "is-visible" : ""
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _91qc9by0 _8fz6e0nm _mezj1mcy _bna71k4y _5nenxk0h _twjk1qjk _14w91a70 _j0lcd4y9 _1jtm14no _rpid14y2 _1h8ed4y9 _1ga514no _1ftj14y2",
                    "top-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("h2", {
                    className: (0, $2jatx.default)([
                        "_k48p1fw0 _1wybckbl _vwz48vuz _19pkidpf _2hwxidpf _otyr1ul9 _18u0idpf _1r3w1ul9 _73n214no _z9soidpf _161zidpf _2a8ridpf _ikcgidpf"
                    ]),
                    children: [
                        heading,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/s31k3rin80p38d25a3wn54b8354r27vm.webp",
                                alt: "",
                                width: 245,
                                height: 279
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_91qc9by0 _jzgezwfg _1q5112am _11q7cd5j",
                    "bottom-section"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "aria-label": formatMessage({
                        id: "jira-product-tour.collaborate-section.carousel",
                        defaultMessage: "Carousel"
                    }),
                    className: (0, $2jatx.default)([
                        "_p12f1uof _1e0c1txw _1n261g80 _zulpzwfg _zzrm1osq _79ty1bp4 _1np61h6o _9et11h6o _1yytidpf",
                        "row-width"
                    ]),
                    role: "region",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half texts"
                            ]),
                            children: options.map((option, index)=>{
                                const src = (0, $hnmMQ.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: "option-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _1wyb1j6v _y3gn1e5h _19pkidpf _2hwxidpf _otyrzwfg _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvgktf _kqswh2mm _4t3i1osq _1vdjzwfg _1bfn10mc _1mjg1tcg _kmcs1ul9 _zpjv1w81 _19141wug _h95w1gmh",
                                                `option ${activeOption == index ? "active" : "inactive"}`
                                            ]),
                                            onClick: ()=>changeActive(index),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_kqswstnw _1e02idpf _152tidpf _u7coidpf _1bsb1l7b _4t3i1osq _bfhk1kby",
                                                        "progress"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_bfhkoelr _4t3iidpf"
                                                        ])
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1tcg _vwz41ul9 _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _v5641fa5 _1496ni7l"
                                                    ]),
                                                    children: option.title
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_v5641qn0 _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq"
                                                    ]),
                                                    children: option.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0cglyw _liwc11p5 _9et11h6o _1np61h6o",
                                                "mobile-images"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                image: {
                                                    src: src,
                                                    alt: option.title
                                                },
                                                style: {
                                                    aspectRatio: "5/4",
                                                    display: isActive ? "block" : "none",
                                                    width: "100%",
                                                    height: "auto"
                                                },
                                                className: (0, $2jatx.default)([
                                                    "_kqswh2mm _p12f1ogm"
                                                ])
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "aria-live": "polite",
                            className: (0, $2jatx.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half images"
                            ]),
                            role: "status",
                            children: options.map((option, index)=>{
                                const src = (0, $hnmMQ.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_liwcglyw",
                                        "desktop-images"
                                    ]),
                                    hidden: !isActive,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                        image: {
                                            src: src,
                                            alt: option.title
                                        },
                                        style: {
                                            aspectRatio: "5/4",
                                            position: "absolute",
                                            width: "100%",
                                            height: "auto"
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $b8e4fdbb89836c28$var$topSectionForPictureStyles = null;
const $b8e4fdbb89836c28$var$mobileImagesStyles = null;
const $b8e4fdbb89836c28$var$desktopImagesStyles = null;
const $b8e4fdbb89836c28$var$rowWidthStyles = null;
const $b8e4fdbb89836c28$var$halfStyles = null;
const $b8e4fdbb89836c28$var$progressStyles = null;
const $b8e4fdbb89836c28$var$buttonStyles = null;
const $b8e4fdbb89836c28$var$optionDescriptionStyles = null;
const $b8e4fdbb89836c28$var$innerDivProgressStyles = null;
const $b8e4fdbb89836c28$var$optionH3Styles = null;
const $b8e4fdbb89836c28$var$bottomSectionStyles = null;
const $b8e4fdbb89836c28$var$optionContainerImageStyles = null;
const $b8e4fdbb89836c28$var$h2Styles = null;
const $b8e4fdbb89836c28$var$empowerStyles = null;

});


parcelRegister("dS67T", function(module, exports) {
$parcel$export(module.exports, "JswDoubleFeatureSection", function () { return $8f8dac8bd8ab28d3$export$fa980c3455a6cd08; });
/* jsw-double-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iNnWi = parcelRequire("iNnWi");

var $7asA7 = parcelRequire("7asA7");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $8f8dac8bd8ab28d3$export$fa980c3455a6cd08 = ()=>{
    const intl = (0, $8e22h.default)();
    const doubleFeatureItems = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-title-text",
                defaultMessage: "Easily see every team\u2019s progress"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-description-text",
                defaultMessage: "Track every team\u2019s work in a single timeline. Understand progress, map dependencies, and stay ahead of risks."
            }),
            image: (0, $iNnWi.getDoubleFeatureFirstImage)(intl.locale)
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-title-text",
                defaultMessage: "Map work to company impact"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-description-text",
                defaultMessage: "With goals in Jira, it\u2019s easy to track all the tasks across projects that contribute to a goal, no matter what team is working on it."
            }),
            image: (0, $iNnWi.getDoubleFeatureSecondImage)(intl.locale)
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1eog16gx _qjx3idpf _1celidpf _5n7aidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _y3gn1h6o _ect41pz4 _1wyb1ylp _k48p1fw0 _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r3w1ul9 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: intl.formatMessage({
                    id: "jira-product-tour.double-feature-section.title-text",
                    defaultMessage: "Never lose sight of the big picture"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _zulp1ul9 _ca0q1u1b _u5f3idpf _n3td10yn _19bvidpf _79ty1bp4 _1np61h6o _1yytzwfg _1eog1u1b _qjx39by0 _1cel10yn _5n7a9by0"
                ]),
                children: doubleFeatureItems.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7asA7.JswDoubleFeatureCard), {
                        title: item.title,
                        description: item.description,
                        image: item.image
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_mkrzzwj5 _bfhkr3uz _4t3ir0r7 _1pby1mrw _1pfh1o8r"
                ])
            })
        ]
    });
};
$8f8dac8bd8ab28d3$export$fa980c3455a6cd08.displayName = "JswDoubleFeatureSection";
const $8f8dac8bd8ab28d3$var$containerStyles = null;
const $8f8dac8bd8ab28d3$var$titleStyles = null;
const $8f8dac8bd8ab28d3$var$cardContainerStyles = null;
const $8f8dac8bd8ab28d3$var$blackShapeStyles = null;

});
parcelRegister("7asA7", function(module, exports) {
$parcel$export(module.exports, "JswDoubleFeatureCard", function () { return $31657ce82e95d787$export$881c15c7192d6044; });
/* double-feature-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $31657ce82e95d787$export$881c15c7192d6044 = ({ title: title, description: description, image: image })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1bsb1diq _zulp1gkc _11q7cd5j _16qs188r _1y8o1diq _zzrm1osq"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_mezj1osq _bna71osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: image,
                        alt: ""
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_syaz1hlo _y3gn1h6o _ect41pz4 _1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1hlo _y3gn1h6o _ect4bzd7 _1wybo7ao _k48p1nn1 _vwz41gkc _ca0qftgi _u5f353f4 _n3td8ved _19bv53f4 _1eogftgi _qjx310yn _1cel10yn _5n7a10yn"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
const $31657ce82e95d787$var$cardStyle = null;
const $31657ce82e95d787$var$titleStyles = null;
const $31657ce82e95d787$var$descriptionStyles = null;
const $31657ce82e95d787$var$imageContainerStyle = null;

});


parcelRegister("1UnBI", function(module, exports) {
$parcel$export(module.exports, "LoggedOutHeroSection", function () { return $98430ad0795e6e5c$export$a8760ddc663c337c; });
/* logged-out-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6V1n4 = parcelRequire("6V1n4");

var $7chqp = parcelRequire("7chqp");

var $8e22h = parcelRequire("8e22h");

var $izdHQ = parcelRequire("izdHQ");

var $iE2db = parcelRequire("iE2db");

var $dmP4q = parcelRequire("dmP4q");
const $98430ad0795e6e5c$export$a8760ddc663c337c = ()=>{
    const intl = (0, $8e22h.default)();
    const headerContent = {
        mainHeadingFirstPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.first-header-text",
            defaultMessage: "Great outcomes"
        }),
        mainHeadingSecondPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.second-header-text",
            defaultMessage: "start with Jira"
        }),
        subHeading: intl.formatMessage({
            id: "jira-product-tour.hero-header.sub-header-text",
            defaultMessage: "The only project management tool you need to plan and track work across every team."
        }),
        buttonText: intl.formatMessage({
            id: "jira-product-tour.hero-header.button-text",
            defaultMessage: "Get Jira free"
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-jpto-organic-optimize-embedded-signup",
        group: "Test",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _p12f1qe4 _4cvr1h6o _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpckbl _tl28idpf _axwi1tcg _1hwcidpf _sp8t1tcg _1gde1bp4 _1wm01tcg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iE2db.LoggedOutHeader), {
                                ...headerContent
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_p12fkbql _1bsb1osq _1wafckbl"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dmP4q.LoggedOutJiraProductTourAccountCreation), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7chqp.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6V1n4.LogoBanner), {})
        ]
    });
};
$98430ad0795e6e5c$export$a8760ddc663c337c.displayName = "LoggedOutHeroSection";
const $98430ad0795e6e5c$var$heroStyles = null;
const $98430ad0795e6e5c$var$containerStyles = null;
const $98430ad0795e6e5c$var$formStyles = null;

});
parcelRegister("6V1n4", function(module, exports) {
$parcel$export(module.exports, "LogoBanner", function () { return $ff933ff67f9e4e4b$export$f856413bacaabd31; });
/* logo-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hI0HU = parcelRequire("hI0HU");

var $abXwn = parcelRequire("abXwn");

var $1yAvB = parcelRequire("1yAvB");

var $38U9C = parcelRequire("38U9C");

var $76f4d = parcelRequire("76f4d");

var $bynL4 = parcelRequire("bynL4");

var $kbpa7 = parcelRequire("kbpa7");
const $ff933ff67f9e4e4b$var$svgArray = [
    (0, $bynL4.NasaLogo),
    (0, $76f4d.AirCanadaLogo),
    (0, $38U9C.VisaLogo),
    (0, $1yAvB.CanvaLogo),
    (0, $abXwn.DominosLogo),
    (0, $hI0HU.FordLogo)
];
const $ff933ff67f9e4e4b$export$f856413bacaabd31 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1hxd _mkrztcy0 _1qv2ewaa"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                "_qtt8glyw _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _tzy415iw _p12f2w76 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahitcz _1eog1ul9 _qjx3idpf _1cel1ul9 _5n7aidpf _liwc11p5 _13gz16hb _9et11h6o _17sl19q2 _4pgi1hwe _1fu1116b _eulesxk5 _tme71sp7 _1odz101s _r5d653f4 _b3uv1f06 _1avyys9h"
            ]),
            children: $ff933ff67f9e4e4b$var$svgArray.map((Component, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    id: `item-${idx}`,
                    className: (0, $2jatx.default)([
                        "_syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _cjbs1ylp _12ra68cl"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {})
                }, idx))
        })
    });
};
$ff933ff67f9e4e4b$export$f856413bacaabd31.displayName = "LogoBanner";
const $ff933ff67f9e4e4b$var$logoBannerStyles = null;
const $ff933ff67f9e4e4b$var$logoContainerStyles = null;
const $ff933ff67f9e4e4b$var$logoStyles = null;

});
parcelRegister("hI0HU", function(module, exports) {
$parcel$export(module.exports, "FordLogo", function () { return $2ec6afa33ab5e2c3$export$22ac95c9dec2accf; });

var $7VQPk = parcelRequire("7VQPk");
const $2ec6afa33ab5e2c3$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "115",
        height: "41",
        viewBox: "0 0 115 41",
        fill: "currentColor",
        role: "img",
        "aria-label": "Ford",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.3414 0.674927C25.954 0.674927 0.511719 9.52522 0.511719 20.4487C0.511719 31.3721 25.954 40.2178 57.3414 40.2178C88.7289 40.2178 114.171 31.3721 114.171 20.4487C114.171 9.52522 88.7266 0.674927 57.3414 0.674927ZM57.3414 38.5218C27.058 38.5218 2.50943 30.4349 2.50943 20.4647C2.50943 10.4944 27.058 2.38007 57.3414 2.38007C87.6249 2.38007 112.171 10.4692 112.171 20.4487C112.171 30.4281 87.6249 38.5149 57.3414 38.5149V38.5218Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.9218 17.9264C46.4007 17.739 48.5789 17.531 49.9869 17.451C50.2978 17.4327 50.3618 17.4373 50.4875 17.5904C50.8651 18.0357 51.3234 18.4057 51.8384 18.6807C51.9825 18.7797 52.1491 18.841 52.3229 18.859C52.4138 18.8581 52.5033 18.8371 52.5851 18.7976C52.6668 18.7581 52.7389 18.701 52.7961 18.6304C52.8642 18.5664 52.9111 18.4829 52.9303 18.3913C52.9495 18.2998 52.9401 18.2045 52.9035 18.1184C52.8189 17.9722 51.8452 17.4327 51.8132 17.2156C51.7927 17.0762 51.9458 17.0464 51.9458 17.0464C52.3523 16.9276 52.731 16.7287 53.0596 16.4614C53.3881 16.1941 53.6599 15.8638 53.8589 15.4899C54.3047 14.635 54.3778 13.4967 53.5641 12.8659C52.8487 12.3059 51.7698 12.3973 50.9104 13.1676C50.5297 13.5183 50.2394 13.9559 50.0643 14.4431C49.8892 14.9302 49.8344 15.4524 49.9047 15.9653C49.9252 16.1299 49.9047 16.1939 49.6898 16.1939C48.3961 16.2967 47.1481 16.3333 45.7629 16.4064C45.6692 16.4064 45.6395 16.3516 45.6944 16.2853C47.2944 13.515 49.6738 11.5402 52.3229 9.59273C52.4967 9.46244 52.4418 9.21101 52.4349 9.00301C57.1984 10.0362 61.8064 11.963 66.7389 11.9242C68.7824 11.9059 70.7367 11.595 72.6064 10.5687C74.2498 9.67502 74.9172 8.84301 74.9675 7.98359C75.0064 7.38473 74.5927 7.00987 74.0029 7.13787C69.0087 8.28073 64.2498 8.28073 59.2829 7.67044C53.6464 6.98473 48.2384 5.5813 42.6315 5.5813C41.7881 5.5813 40.9424 5.6133 40.0875 5.68416C34.6681 6.1413 29.5115 9.19273 29.5001 13.8259C29.5001 16.1733 31.1641 18.0796 33.7538 17.995C36.7915 17.8899 39.2898 15.4556 40.5995 12.3859C41.0955 11.2179 40.1767 10.7356 39.7378 11.4053C38.9816 12.5797 37.9217 13.5275 36.6704 14.1482C35.2372 14.8476 33.7104 14.6579 33.2418 13.4967C32.5904 11.8556 33.9458 9.4053 37.0384 8.23959C41.5069 6.58473 46.1812 7.67959 50.6772 8.5253C50.7389 8.5253 50.9789 8.65787 50.7687 8.7653C49.7477 9.25956 48.7956 9.88504 47.9367 10.6259C46.8736 11.497 45.8899 12.4608 44.9972 13.5059C44.1058 14.5893 43.4727 15.563 42.6384 16.6304C42.6102 16.6728 42.5727 16.708 42.5287 16.7334C42.4847 16.7587 42.4354 16.7736 42.3847 16.7767C40.3367 17.131 38.3458 17.3596 36.5218 18.619C36.1469 18.8796 35.9847 19.339 36.2109 19.6956C36.2693 19.7689 36.3417 19.8298 36.4239 19.8748C36.506 19.9198 36.5963 19.948 36.6895 19.9578C36.7827 19.9676 36.8769 19.9587 36.9666 19.9318C37.0563 19.9048 37.1397 19.8603 37.2121 19.8007C38.2556 18.9932 39.5317 18.5436 40.8509 18.5184C40.9081 18.5184 40.9355 18.5344 40.9538 18.5687C40.9577 18.5849 40.9579 18.6017 40.9543 18.618C40.9507 18.6342 40.9435 18.6494 40.9332 18.6624C38.9287 21.4442 38.4189 22.0727 36.9195 23.7962C36.1743 24.6452 35.3806 25.4503 34.5424 26.2076C31.1138 29.387 27.4384 29.3322 26.1149 27.3505C25.7719 26.8382 25.5751 26.242 25.5457 25.6262C25.5163 25.0104 25.6554 24.3982 25.9481 23.8556C26.5858 22.5779 27.8704 21.6453 28.9424 21.099C29.3401 20.8956 29.4544 20.3859 29.0567 19.9219C28.8052 19.6224 28.1904 19.5676 27.7332 19.6522C26.3321 19.9104 24.6727 20.971 23.6966 22.2464C22.56 23.6964 22.0329 25.5321 22.2269 27.3642C22.5606 30.8865 25.4544 32.9162 28.7435 32.891C31.3629 32.8705 33.8269 32.0796 36.7938 29.067C39.5572 26.2579 42.0784 22.0659 44.4395 18.1733C44.5127 18.0453 44.5675 17.9699 44.9218 17.9264ZM51.8909 13.8602C52.0025 13.736 52.1556 13.6569 52.3214 13.6375C52.4872 13.6181 52.6543 13.6599 52.7915 13.755C53.0544 13.9836 52.9309 14.539 52.6635 14.9299C52.3735 15.3647 51.9359 15.6797 51.4315 15.8167H51.3972C51.3218 15.8167 51.2601 15.7642 51.2258 15.5882C51.1896 15.2679 51.2311 14.9436 51.3469 14.6428C51.4627 14.3419 51.6493 14.0735 51.8909 13.8602Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.5408 13.7385H89.5031C89.2745 13.7385 89.1625 13.7682 89.0574 13.9671C88.7054 14.6368 84.4516 21.0117 83.6608 22.2482C83.5305 22.4357 83.3659 22.4082 83.3454 22.1957C83.2676 21.4597 82.6322 20.6162 81.6311 20.2117C80.9069 19.9192 80.117 19.8283 79.3454 19.9488C77.9465 20.1362 76.7008 20.8631 75.6036 21.7065C73.9556 22.9637 72.5294 24.5911 70.6916 25.7934C69.6836 26.4585 68.3122 27.0254 67.3979 26.1751C66.5659 25.4025 66.6596 23.6882 67.9305 22.3602C68.0676 22.2231 68.2276 22.3397 68.2025 22.4631C68.1338 22.7513 68.1425 23.0525 68.2276 23.3362C68.3127 23.62 68.4712 23.8763 68.6871 24.0791C68.9628 24.3176 69.3042 24.4672 69.6665 24.508C70.0288 24.5488 70.3949 24.4789 70.7168 24.3077C71.1004 24.1091 71.4297 23.8197 71.6759 23.4648C71.9221 23.1098 72.0778 22.7 72.1294 22.2711C72.1744 21.9558 72.1541 21.6346 72.0697 21.3275C71.9854 21.0204 71.8387 20.7339 71.6389 20.4859C71.4391 20.2378 71.1904 20.0336 70.9083 19.8857C70.6262 19.7379 70.3167 19.6497 69.9991 19.6265C68.9385 19.5534 67.9237 19.9214 66.9362 20.7397C66.468 21.1167 66.0609 21.5639 65.7294 22.0654C65.6219 22.214 65.4619 22.23 65.4688 22.006C65.5168 20.2757 64.7991 19.2997 63.3682 19.2631C62.2551 19.238 61.0688 19.8391 60.1408 20.5797C59.1282 21.3934 58.2391 22.4722 57.2882 23.4894C57.1694 23.6151 57.0596 23.6082 57.0345 23.366C57.0048 22.2231 56.7145 21.1054 56.1842 20.3168C56.087 20.1724 55.9398 20.0692 55.771 20.027C55.6021 19.9848 55.4236 20.0066 55.2699 20.0882C54.891 20.269 54.5298 20.4848 54.1911 20.7328C54.0929 20.8138 54.0225 20.9234 53.9897 21.0464C53.9569 21.1693 53.9634 21.2994 54.0082 21.4185C54.5153 23.1725 54.4097 25.0469 53.7088 26.7328C53.0711 28.2437 51.8276 29.6014 50.3694 30.0654C49.4094 30.3671 48.4082 30.2185 47.7888 29.366C46.9408 28.1911 47.2836 26.1431 48.5476 24.4471C49.6676 22.95 51.2905 22.0014 52.8905 21.3865C52.9278 21.3788 52.9629 21.3627 52.9931 21.3394C53.0232 21.3161 53.0477 21.2863 53.0647 21.2522C53.0816 21.2181 53.0906 21.1805 53.0909 21.1424C53.0912 21.1043 53.0829 21.0666 53.0665 21.0322C52.9774 20.7648 52.8379 20.406 52.7831 20.2414C52.6322 19.8482 52.2208 19.7842 51.7134 19.8391C50.5628 19.9917 49.4524 20.3642 48.4425 20.9362C45.6996 22.3991 44.3282 25.2311 43.7385 26.7488C43.5351 27.3179 43.2453 27.8521 42.8791 28.3328C42.4494 28.8723 41.9076 29.366 40.9179 30.2345C40.8649 30.2853 40.8289 30.3512 40.815 30.4233C40.8011 30.4954 40.8099 30.57 40.8402 30.6368C40.9408 30.8425 41.4574 31.5694 41.5991 31.638C41.6734 31.6578 41.7516 31.6586 41.8263 31.6402C41.901 31.6218 41.9699 31.5849 42.0265 31.5328C42.7381 31.0436 43.3848 30.466 43.9511 29.814C44.0951 29.6448 44.2391 29.718 44.3145 29.9785C44.4953 30.6541 44.84 31.2745 45.3181 31.7849C45.7961 32.2953 46.3928 32.6798 47.0551 32.9043C49.5694 33.7523 52.1591 32.5294 54.1225 30.39C55.3682 29.0368 55.8208 28.166 56.2985 27.574C57.1122 26.5705 58.7122 24.326 60.6094 22.886C61.3065 22.3511 62.1339 21.9442 62.5476 22.214C62.8814 22.4425 62.9888 22.934 62.4539 23.9054C60.5134 27.4482 57.6539 31.6128 57.1351 32.6208C57.0368 32.7991 57.1351 32.934 57.3065 32.934C58.3236 32.934 59.3294 32.934 60.2505 32.934C60.312 32.9324 60.372 32.9144 60.4243 32.8819C60.4765 32.8493 60.5191 32.8034 60.5476 32.7488C62.0379 30.4174 63.4391 28.2002 64.9408 25.9054C65.0254 25.7705 65.1031 25.8757 65.1054 25.9351C65.1396 26.4654 65.2676 27.1945 65.5854 27.6722C65.8183 28.0636 66.1499 28.387 66.547 28.6101C66.9441 28.8331 67.3928 28.9479 67.8482 28.9431C68.5591 28.9431 68.9202 28.8425 69.6768 28.5545C70.2133 28.3555 70.7201 28.084 71.1831 27.7477C71.4116 27.59 71.4482 27.8528 71.4414 27.894C71.0962 29.7431 71.5236 31.9351 73.3637 32.8448C75.5625 33.9283 77.9808 32.406 79.3751 31.0277C79.5076 30.8951 79.6539 30.9088 79.6699 31.1945C79.7065 31.7943 79.9552 32.3614 80.3717 32.7945C81.5374 33.9625 83.8894 33.4985 86.2505 31.67C87.7659 30.502 89.3545 28.8471 90.7854 27.0985C90.8043 27.0796 90.8193 27.0572 90.8296 27.0325C90.8398 27.0078 90.8451 26.9813 90.8451 26.9545C90.8451 26.9278 90.8398 26.9013 90.8296 26.8766C90.8193 26.8519 90.8043 26.8294 90.7854 26.8105C90.5568 26.582 90.2528 26.3237 90.0357 26.1248C89.9887 26.089 89.9313 26.0697 89.8722 26.0697C89.8132 26.0697 89.7558 26.089 89.7088 26.1248C88.2414 27.5237 86.9179 29.1168 85.0094 30.4334C84.3625 30.8905 83.3362 31.2494 82.8745 30.6231C82.6939 30.3808 82.7145 30.0448 82.8928 29.606C83.4482 28.2162 92.2642 14.79 92.7214 13.9945C92.8036 13.8391 92.7214 13.7385 92.5408 13.7385ZM81.0665 25.238C81.0848 25.3431 81.2174 25.4414 81.3476 25.4871C81.3956 25.5031 81.4208 25.5397 81.3705 25.6448C81.031 26.3334 80.6333 26.9918 80.1819 27.6128C79.7627 28.23 79.2525 28.7802 78.6688 29.2448C77.9831 29.8117 77.0917 30.4174 76.2505 30.4174C75.9983 30.4206 75.7493 30.3609 75.5259 30.2437C75.0688 30.0151 74.8745 29.3728 74.8814 28.8585C74.9065 27.414 75.5488 25.9305 76.7351 24.4722C78.1819 22.6894 79.7819 21.766 80.8311 22.2711C81.9191 22.79 81.5739 24.0448 81.0871 25.0345C81.0538 25.097 81.0464 25.1701 81.0665 25.238Z"
            })
        ]
    });

});

parcelRegister("abXwn", function(module, exports) {
$parcel$export(module.exports, "DominosLogo", function () { return $3dcbc0b04b75e475$export$3a87515d6bae358a; });

var $7VQPk = parcelRequire("7VQPk");
const $3dcbc0b04b75e475$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "149",
        height: "33",
        viewBox: "0 0 149 33",
        fill: "currentColor",
        role: "img",
        "aria-label": "Domino\u2019s",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.1443 21.4717C83.5509 17.7341 78.0566 18.8925 76.5524 21.2925V19.4237H71.7656V32.6781H76.7245V26.0093C76.7245 23.5197 77.2535 23.3405 78.5856 23.2509C79.9114 23.1613 80.4468 23.3405 80.4468 26.0093L80.536 32.6781H85.3228V25.8301C85.3228 24.5821 85.5905 23.4301 86.9162 23.4301C88.5097 23.3405 88.8666 23.5197 88.8666 25.4781V32.7741H93.9147V22.8925C94.004 18.1821 87.3624 18.0925 85.1443 21.4717Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M63.1736 18.4457C59.2729 18.4457 56.0859 21.6457 56.0859 25.5625C56.0859 29.4793 59.2729 32.6793 63.1736 32.6793C67.0744 32.6793 70.2614 29.4793 70.2614 25.5625C70.2614 21.6457 67.0744 18.4457 63.1736 18.4457ZM63.1736 28.0521C61.7587 28.0521 60.6942 26.8937 60.6942 25.5625C60.6942 24.1417 61.8479 23.0729 63.1736 23.0729C64.4994 23.0729 65.6531 24.2313 65.6531 25.5625C65.6594 26.9001 64.5058 28.0521 63.1736 28.0521Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M49.7117 15.1528C48.7365 14.7112 47.7613 14.3528 46.6969 14.2632C45.1927 14.084 43.6821 13.9944 42.1778 13.9944H36.6836V32.676H41.7317C43.4144 32.676 45.0971 32.5864 46.6905 32.4072C47.755 32.228 48.8194 31.9656 49.7882 31.5176C51.2924 30.7176 52.6246 29.5592 53.5998 28.1384C55.3717 25.2008 55.3717 21.4696 53.5998 18.532C52.6373 17.1112 51.3052 15.9528 49.7117 15.1528ZM49.0935 25.5592C48.7365 26.18 48.2075 26.8072 47.5 27.1592C47.1431 27.3384 46.7033 27.5176 46.2571 27.6008C45.5496 27.6904 44.9313 27.78 44.2175 27.6904H42.1778V18.8904H44.4788C45.0971 18.8904 45.7217 18.8904 46.34 18.98C46.7798 19.0696 47.2259 19.1592 47.5829 19.4216C48.2011 19.78 48.7365 20.3112 49.1763 21.0216C49.5333 21.732 49.7053 22.532 49.7053 23.2424C49.6225 24.0488 49.444 24.8488 49.0935 25.5592Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M101.002 19.1608H96.043V32.5944H101.002V19.1608Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.701 16.4923C136.88 15.6923 136.88 14.8027 136.523 14.0923C136.083 13.1131 135.108 12.4923 134.044 12.4923C132.801 12.4027 131.653 13.2923 131.386 14.4507C131.029 15.8715 131.825 17.2987 133.247 17.7403C133.604 17.8299 133.954 17.7403 133.687 18.1819C133.419 18.5403 133.068 18.8923 132.711 19.1611L133.24 19.9611C135.376 18.8027 136.44 17.6443 136.701 16.4923Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M125.541 18.4457C121.64 18.4457 118.453 21.6457 118.453 25.5625C118.453 29.4793 121.64 32.6793 125.541 32.6793C129.442 32.6793 132.629 29.4793 132.629 25.5625C132.629 21.6457 129.442 18.4457 125.541 18.4457ZM125.541 28.0521C124.126 28.0521 123.061 26.8937 123.061 25.5625C123.061 24.2313 124.215 23.0729 125.541 23.0729C126.867 23.0729 128.02 24.2313 128.02 25.5625C128.02 26.9001 126.956 28.0521 125.541 28.0521Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M142.286 23.6923C139.807 23.6923 139.985 22.0027 141.49 21.9131C143.083 21.8235 144.677 22.2715 145.919 23.2443L147.513 20.1339C143.172 17.5547 135.817 17.9131 135.645 22.6235C135.556 25.2923 137.595 26.6235 141.757 27.0715C144.772 27.4299 143.886 28.7611 142.197 28.9403C140.514 29.1195 138.921 28.3195 137.238 27.3403L135.109 30.5403C140.954 34.2779 147.774 32.5883 148.042 28.2299C148.31 25.6507 146.27 23.6027 142.286 23.6923Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M108.089 21.2934V19.4246H103.303V32.679H108.089V26.0102C108.089 23.7894 109.065 23.3414 110.129 23.2518C111.455 23.0726 112.43 23.3414 112.43 26.0102L112.519 32.679H117.306V22.983C117.217 18.183 109.951 18.183 108.089 21.2934Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M98.5225 12.4861C97.0183 12.4861 95.7754 13.7341 95.7754 15.2445C95.7754 16.7549 97.0183 18.0029 98.5225 18.0029C100.027 18.0029 101.27 16.7549 101.27 15.2445C101.27 13.7341 100.027 12.4861 98.5225 12.4861Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.8143 10.4361L22.5148 1.09853C22.075 0.656934 21.4504 0.656934 21.0106 1.09853L11.1758 10.8841L21.9858 21.7385L31.8206 11.9529C32.2604 11.5049 32.2604 10.8841 31.8143 10.4361ZM23.7577 12.9321C22.6933 14.0009 21.0106 14.0009 20.0354 12.9321C18.971 11.8633 18.971 10.1737 20.0354 9.19453C21.0998 8.12573 22.7825 8.12573 23.7577 9.19453C24.7329 10.1737 24.7329 11.8633 23.7577 12.9321Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.5567 11.5936L0.632581 21.4688C0.192786 21.9104 0.192786 22.5376 0.632581 22.9792L9.93202 32.3168C10.3718 32.7584 10.9964 32.7584 11.4362 32.3168L21.2711 22.5376L10.5567 11.5936ZM8.60626 24.2272C7.54183 25.2064 5.85913 25.2064 4.88393 24.2272C3.8195 23.1584 3.8195 21.4688 4.88393 20.4896C5.94836 19.5104 7.63106 19.5104 8.60626 20.4896C9.58145 21.4688 9.58145 23.1584 8.60626 24.2272ZM12.5899 24.2272C11.5255 23.248 11.5255 21.4688 12.5899 20.4896C13.6543 19.4208 15.337 19.4208 16.3122 20.4896C17.3767 21.5584 17.3767 23.248 16.3122 24.2272C15.2478 25.296 13.6543 25.296 12.5899 24.2272Z"
            })
        ]
    });

});

parcelRegister("1yAvB", function(module, exports) {
$parcel$export(module.exports, "CanvaLogo", function () { return $627549377313d3c5$export$41d9e6d43cf45e91; });

var $7VQPk = parcelRequire("7VQPk");
const $627549377313d3c5$export$41d9e6d43cf45e91 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "73",
        height: "73",
        viewBox: "0 0 73 73",
        fill: "currentColor",
        role: "img",
        "aria-label": "Canva",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M51.3643 35.0746C50.9233 35.0746 50.7793 35.6686 50.7793 36.1096C50.8126 36.9942 51.1568 37.8387 51.7513 38.4946C51.9811 37.9215 52.106 37.3118 52.1203 36.6946C52.1023 35.5966 51.6613 35.0746 51.3643 35.0746Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.4512 0.69458C29.3311 0.69458 22.3708 2.80594 16.4507 6.76167C10.5305 10.7174 5.91628 16.3398 3.19152 22.918C0.46677 29.4961 -0.24615 36.7345 1.14292 43.7178C2.53199 50.7011 5.96065 57.1157 10.9953 62.1504C16.03 67.1851 22.4446 70.6138 29.4279 72.0029C36.4113 73.3919 43.6497 72.679 50.2278 69.9542C56.8059 67.2295 62.4284 62.6153 66.3841 56.6951C70.3398 50.7749 72.4512 43.8147 72.4512 36.6946C72.4512 27.1468 68.6583 17.99 61.907 11.2387C55.1557 4.48743 45.999 0.69458 36.4512 0.69458ZM62.3892 46.4686C62.2848 46.4807 62.1794 46.4552 62.0922 46.3966C61.4858 46.201 60.9422 45.848 60.5169 45.3737C60.0915 44.8993 59.7997 44.3206 59.6712 43.6966C59.4147 44.0614 59.0735 44.3584 58.6769 44.5622C58.2803 44.766 57.8401 44.8705 57.3942 44.8666C56.6375 44.8137 55.9229 44.4992 55.3728 43.977C54.8226 43.4548 54.4714 42.7575 54.3792 42.0046C54.3079 41.31 54.3815 40.6083 54.5952 39.9436C54.0646 40.309 53.4392 40.5123 52.7952 40.5286H52.2822C51.2379 42.1236 49.8891 43.4968 48.3132 44.5696C47.9532 44.7729 47.5547 44.8986 47.1432 44.9386C47.0175 44.945 46.8921 44.9223 46.7766 44.8724C46.6611 44.8224 46.5586 44.7465 46.4772 44.6506C46.2312 44.3978 46.0396 44.0972 45.9143 43.7675C45.7889 43.4378 45.7324 43.086 45.7482 42.7336C44.5868 44.0553 42.9904 44.9174 41.2482 45.1636C41.0186 45.172 40.7896 45.1348 40.5745 45.054C40.3593 44.9733 40.1624 44.8507 39.9949 44.6934C39.8275 44.536 39.693 44.347 39.5992 44.1373C39.5053 43.9275 39.454 43.7013 39.4482 43.4716C39.4004 43.0775 39.4248 42.6779 39.5202 42.2926C39.8189 40.8972 40.2098 39.5232 40.6902 38.1796C40.6902 38.0356 40.6182 37.9636 40.5462 37.9636C39.8172 37.9636 37.3152 40.5286 36.9462 42.2206L36.6492 43.6156C36.5554 44.0328 36.3297 44.4087 36.0055 44.6876C35.6812 44.9664 35.2758 45.1333 34.8492 45.1636C34.7031 45.1712 34.5598 45.1221 34.4491 45.0265C34.3384 44.9309 34.2689 44.7962 34.2552 44.6506V44.2096L34.4082 43.4716C33.4455 44.2995 32.2918 44.8748 31.0512 45.1456C30.6669 45.1923 30.2794 45.0879 29.9705 44.8546C29.6616 44.6212 29.4553 44.277 29.3952 43.8946C29.145 44.2716 28.8072 44.5824 28.4106 44.8003C28.0141 45.0181 27.5706 45.1366 27.1182 45.1456C26.5535 45.121 26.0067 44.9396 25.5394 44.6216C25.072 44.3037 24.7024 43.8618 24.4722 43.3456C23.6937 44.2137 22.8075 44.9789 21.8352 45.6226C20.3011 46.7055 18.4907 47.3298 16.6152 47.4226C15.018 47.3779 13.4957 46.7355 12.3492 45.6226C11.105 44.3767 10.3293 42.7394 10.1532 40.9876C9.45119 35.7946 12.6462 28.9816 17.5512 26.0386C18.6183 25.3792 19.843 25.0187 21.0972 24.9946C22.1451 24.9667 23.1666 25.3257 23.9667 26.003C24.7669 26.6803 25.2896 27.6284 25.4352 28.6666C25.5805 29.5671 25.4134 30.4903 24.9615 31.2827C24.5096 32.0751 23.8002 32.6891 22.9512 33.0226C21.9252 33.5356 21.4122 33.5356 21.2592 33.2386C21.2132 33.1384 21.2033 33.0254 21.2311 32.9187C21.259 32.8121 21.323 32.7184 21.4122 32.6536C23.3202 31.1146 23.3202 29.7916 23.0952 27.9556C23.094 27.4674 22.9074 26.998 22.5733 26.6421C22.2391 26.2862 21.7823 26.0705 21.2952 26.0386C17.4792 26.0386 12.1872 34.3456 12.9252 40.3666C13.2132 42.7156 14.7252 45.4336 17.6232 45.4336C18.6458 45.4096 19.6506 45.1607 20.5662 44.7046C21.9121 44.1221 23.0998 43.2274 24.0312 42.0946C23.8152 39.3046 26.2362 35.7946 29.7642 35.7946C31.3122 35.7946 32.5542 36.3796 32.7072 37.5946C32.7491 37.8246 32.7377 38.0613 32.674 38.2862C32.6102 38.5112 32.4957 38.7186 32.3392 38.8924C32.1828 39.0662 31.9886 39.2019 31.7715 39.2889C31.5545 39.376 31.3204 39.4121 31.0872 39.3946C30.6462 39.3946 29.9892 39.2506 29.9082 38.8816C29.8272 38.5126 30.8712 38.6656 30.7182 37.7026C30.6462 37.1176 29.9892 36.9016 29.3952 36.9016C27.1902 36.9016 25.9482 39.9886 26.1642 41.8966C26.2362 42.7966 26.7492 43.6966 27.4872 43.6966C28.2252 43.6966 29.1072 42.7426 29.3952 41.4196C29.4903 41.003 29.7164 40.6279 30.0403 40.3492C30.3643 40.0706 30.7691 39.9032 31.1952 39.8716C31.5642 39.8716 31.7892 40.0246 31.7892 40.3846V40.8256C31.7082 41.1946 31.4202 42.6256 31.4202 42.8146C31.4177 42.8921 31.4311 42.9693 31.4596 43.0414C31.4881 43.1135 31.5311 43.179 31.586 43.2338C31.6408 43.2886 31.7063 43.3316 31.7784 43.3601C31.8505 43.3887 31.9277 43.4021 32.0052 43.3996C33.0226 43.0491 33.9462 42.4703 34.7052 41.7076C35.0742 39.9076 35.5152 37.5946 35.5152 37.4506C35.5289 37.2199 35.5905 36.9945 35.696 36.7889C35.8016 36.5833 35.9488 36.402 36.1282 36.2563C36.3077 36.1107 36.5155 36.0041 36.7385 35.9432C36.9614 35.8823 37.1946 35.8684 37.4232 35.9026C37.5698 35.8952 37.7133 35.9458 37.8228 36.0435C37.9323 36.1412 37.9989 36.2781 38.0082 36.4246V36.8566L37.6482 38.8456C38.9712 37.0456 41.0232 35.7586 42.2742 35.7586C42.5153 35.7419 42.754 35.8156 42.9437 35.9654C43.1334 36.1151 43.2605 36.3302 43.3002 36.5686C43.3143 37.0429 43.2411 37.5158 43.0842 37.9636C42.5581 39.4664 42.1459 41.0068 41.8512 42.5716C41.819 42.6702 41.8121 42.7752 41.831 42.8772C41.8498 42.9792 41.894 43.0748 41.9593 43.1554C42.0246 43.2359 42.1091 43.2988 42.205 43.3383C42.3008 43.3778 42.4051 43.3927 42.5082 43.3816C43.183 43.2388 43.8229 42.9641 44.3913 42.5734C44.9596 42.1826 45.4452 41.6835 45.8202 41.1046V40.3666C45.764 39.3003 45.8888 38.2322 46.1892 37.2076C46.3356 36.8008 46.591 36.4421 46.9275 36.1707C47.264 35.8992 47.6686 35.7255 48.0972 35.6686C48.1761 35.66 48.2559 35.6693 48.3308 35.6957C48.4056 35.7221 48.4736 35.7649 48.5297 35.821C48.5859 35.8772 48.6287 35.9451 48.6551 36.02C48.6815 36.0949 48.6907 36.1747 48.6822 36.2536C48.6934 36.4042 48.6688 36.5554 48.6102 36.6946C48.1656 37.948 47.9166 39.2624 47.8722 40.5916C47.8865 41.3998 47.9799 42.2046 48.1512 42.9946C48.1469 43.0243 48.1495 43.0547 48.1587 43.0833C48.1679 43.1119 48.1835 43.138 48.2044 43.1597C48.2252 43.1814 48.2507 43.1981 48.2789 43.2084C48.3071 43.2188 48.3373 43.2226 48.3672 43.2196C49.4848 42.374 50.4059 41.2962 51.0672 40.0606C50.5825 39.7281 50.1924 39.2755 49.9352 38.747C49.6781 38.2184 49.5626 37.6322 49.6002 37.0456C49.6002 34.8406 50.9232 33.6616 52.2462 33.6616C52.522 33.6642 52.794 33.7254 53.0443 33.8413C53.2946 33.9571 53.5174 34.1249 53.6979 34.3335C53.8783 34.542 54.0123 34.7866 54.091 35.0509C54.1697 35.3152 54.1912 35.5933 54.1542 35.8666C54.09 36.9274 53.782 37.9591 53.2542 38.8816H53.5512C53.8931 38.8929 54.2332 38.8258 54.5452 38.6854C54.8572 38.545 55.1329 38.335 55.3512 38.0716C55.4796 37.928 55.6282 37.8037 55.7922 37.7026C56.3143 37.051 56.9738 36.5227 57.7237 36.1556C58.4736 35.7884 59.2953 35.5914 60.1302 35.5786C61.6692 35.5786 62.9202 36.1636 63.0642 37.3786C63.105 37.6131 63.0938 37.8537 63.0316 38.0835C62.9693 38.3133 62.8575 38.5266 62.7039 38.7085C62.5504 38.8904 62.3588 39.0364 62.1427 39.1363C61.9266 39.2362 61.6912 39.2875 61.4532 39.2866C61.0122 39.2866 60.2742 39.1426 60.2742 38.7736C60.2742 38.4046 61.2282 38.5486 61.1742 37.5946C61.1022 37.0096 60.4362 36.6946 59.8512 36.6946C57.7902 36.6946 56.3952 39.3946 56.6202 41.6896C56.6922 42.5896 57.1332 43.4896 57.9432 43.4896C58.6002 43.4896 59.5542 42.5356 59.9232 41.2126C60.0332 40.8046 60.2639 40.4393 60.5851 40.1647C60.9063 39.89 61.303 39.7189 61.7232 39.6736C61.7963 39.6632 61.8709 39.6688 61.9417 39.6899C62.0125 39.7109 62.0779 39.7471 62.1334 39.7958C62.189 39.8445 62.2334 39.9046 62.2635 39.9721C62.2937 40.0395 62.3089 40.1127 62.3082 40.1866C62.2297 40.8778 62.1064 41.5633 61.9392 42.2386C61.8296 42.747 61.7812 43.2667 61.7952 43.7866C61.8989 44.4661 62.2138 45.0959 62.6952 45.5866C62.8071 45.6829 62.8859 45.812 62.9202 45.9556C62.9365 46.0279 62.934 46.1033 62.9127 46.1744C62.8915 46.2455 62.8523 46.3099 62.799 46.3614C62.7456 46.413 62.6799 46.4499 62.6081 46.4687C62.5363 46.4874 62.4609 46.4874 62.3892 46.4686Z"
            })
        ]
    });

});

parcelRegister("38U9C", function(module, exports) {
$parcel$export(module.exports, "VisaLogo", function () { return $864117658491d5fa$export$c17820a482ea0e7b; });

var $7VQPk = parcelRequire("7VQPk");
const $864117658491d5fa$export$c17820a482ea0e7b = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "61",
        height: "19",
        viewBox: "0 0 61 19",
        fill: "currentColor",
        role: "img",
        "aria-label": "Visa",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M44.4329 0.753178C43.0385 0.245085 41.5646 -0.00987869 40.0805 0.000292741C35.2812 0.000292741 31.8917 2.41793 31.8677 5.88841C31.8378 8.43803 34.2764 9.87481 36.1211 10.7267C38.0138 11.6026 38.6467 12.1545 38.6407 12.9374C38.6287 14.1282 37.129 14.6681 35.7342 14.6681C33.8175 14.6681 32.7706 14.4011 31.1599 13.7322L30.5629 13.4533L29.882 17.4487C31.0489 17.9346 33.1516 18.3515 35.3232 18.3875C40.4255 18.3875 43.761 15.9849 43.8 12.2924C43.8419 10.2558 42.5221 8.71698 39.7446 7.44517C38.0558 6.6203 37.009 6.06838 37.009 5.23151C37.009 4.49062 37.9058 3.69874 39.7806 3.69874C41.0282 3.66855 42.2682 3.90264 43.419 4.38563L43.8689 4.5866L44.5498 0.726183L44.4329 0.753178ZM56.887 0.324244H53.1376C51.9707 0.324244 51.0919 0.645195 50.5819 1.80302L43.371 18.1386H48.4733L49.4931 15.46L55.7202 15.466C55.8672 16.0929 56.3171 18.1386 56.3171 18.1386H60.8164L56.887 0.324244ZM24.9658 0.174265H29.8281L26.7865 17.9976H21.9302L24.9658 0.168267V0.174265ZM12.6226 9.99779L13.1266 12.4724L17.8778 0.324244H23.0281L15.3762 18.1146H10.238L6.03862 3.05083C5.97061 2.80245 5.81088 2.58912 5.59169 2.45392C4.07812 1.67205 2.47439 1.07871 0.816406 0.687187L0.882396 0.312243H8.70822C9.77006 0.354237 10.6249 0.687188 10.9099 1.82102L12.6196 10.0068L12.6226 9.99779ZM50.8879 11.8155L52.8256 6.83027C52.8016 6.88426 53.2245 5.80142 53.4705 5.13252L53.8035 6.67129L54.9283 11.8125H50.8849L50.8879 11.8155Z"
        })
    });

});

parcelRegister("76f4d", function(module, exports) {
$parcel$export(module.exports, "AirCanadaLogo", function () { return $c116e0278aa92ff1$export$ea8385ffd753ff4e; });

var $7VQPk = parcelRequire("7VQPk");
const $c116e0278aa92ff1$export$ea8385ffd753ff4e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "185",
        height: "24",
        viewBox: "0 0 185 24",
        fill: "currentColor",
        role: "img",
        "aria-label": "Air Canada",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.8603 17.077C12.8603 16.2693 13.2065 16.1539 14.0142 16.6154C15.3988 17.4231 16.7834 18.1154 16.7834 18.1154C16.7834 17.6539 17.2449 17.3077 18.0526 17.5385C18.8603 17.7693 19.668 17.8847 19.668 17.8847C19.668 17.8847 19.2065 16.8462 18.9757 16.3847C18.6295 15.577 18.9757 15.1154 19.3218 15C19.3218 15 18.8603 14.6539 18.5141 14.4231C17.8218 13.9616 17.9372 13.3847 18.6295 13.1539C19.5526 12.6924 20.8218 12.2308 20.8218 12.2308C20.4757 12.0001 20.0142 11.4231 20.4757 10.6154C20.9372 9.92312 21.7449 8.88466 21.7449 8.88466H19.5526C18.7449 8.88466 18.5141 8.19234 18.5141 7.73081C18.5141 7.73081 17.2449 8.6539 16.3218 9.23083C15.5142 9.80775 14.8218 9.23083 14.9372 8.30774C15.168 6.92313 15.2834 5.30775 15.2834 5.30775C14.8219 5.76928 14.0141 5.65391 13.5526 4.96159C12.9757 3.80774 12.3988 2.42312 12.3988 2.42312C12.3988 2.42312 11.8218 3.80774 11.2449 4.96159C10.8987 5.65391 10.0911 5.76928 9.62953 5.42312C9.62953 5.42312 9.74493 7.03849 9.97569 8.42311C10.0911 9.2308 9.39877 9.80772 8.59108 9.2308C7.66799 8.65387 6.28338 7.73079 6.28338 7.73079C6.28338 8.19232 6.05261 8.76924 5.24492 8.88464H3.05262C3.05262 8.88464 3.86031 9.92309 4.32184 10.6154C4.78337 11.3077 4.32184 12 3.97568 12.2308C3.97568 12.2308 5.12953 12.8077 6.16798 13.1539C6.8603 13.5 7.09107 13.9616 6.28338 14.4231C6.05261 14.6539 5.47569 15 5.47569 15C5.93722 15.1154 6.28338 15.5769 5.93722 16.3846C5.70645 16.8462 5.2449 17.8846 5.2449 17.8846C5.2449 17.8846 6.05259 17.6539 6.86028 17.5385C7.66797 17.3077 8.01413 17.7692 8.1295 18.1154C8.1295 18.1154 9.51411 17.3077 10.8987 16.6154C11.591 16.1539 12.0526 16.3846 12.0526 17.0769V19.0385C12.0526 20.1923 11.8218 21.3462 11.4756 22.0385C6.28335 21.4615 1.89872 17.3077 1.89872 11.7692C1.89872 6.11538 6.62948 1.50001 12.5141 1.50001C18.3987 1.50001 23.1295 6.11541 23.1295 11.7692C23.1295 17.0769 18.9756 21.4615 13.668 22.0385V23.4231C19.8987 22.8461 24.7449 17.8846 24.7449 11.7692C24.7449 5.1923 19.2064 0 12.3987 0C5.70643 0 0.167969 5.1923 0.167969 11.6538C0.167969 17.3077 4.43721 22.0385 10.0911 23.0769C11.0141 23.3077 11.5911 23.4231 12.168 24C12.7449 22.8461 12.8603 20.5384 12.8603 19.2692V17.077Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.3613 17.8843V5.42273H68.4767C71.7075 5.42273 73.2075 6.80734 73.3229 8.53812C73.3229 9.34581 73.2075 10.1535 72.6306 10.7304C72.0537 11.3073 71.8229 11.5381 70.7844 12.115L75.3998 17.9997H72.0537L67.8998 12.692H65.1306V17.8843L62.3613 17.8843ZM65.1306 11.0766H66.3998C69.7459 11.0766 70.4383 10.4997 70.4383 8.88428C70.4383 7.2689 68.9382 7.03814 66.7459 7.03814H65.1306V11.0766Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.0156 17.8843L40.4387 5.42273H43.7849L49.208 17.8843H45.8618L44.3618 14.5381H38.5926L37.0926 17.8843H35.0156ZM39.2849 12.9228H43.5541L41.3618 7.96122L39.2849 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.9002 5.42273H53.0156V17.8843H55.9002V5.42273Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.1674 17.4227C94.7827 17.9997 93.052 18.2304 90.9751 18.2304C88.552 18.2304 86.5904 17.6535 85.2058 16.4996C83.8213 15.3458 83.1289 13.7304 83.1289 11.6535C83.1289 9.57654 83.8212 7.84579 85.2058 6.80731C86.5905 5.65346 88.552 5.07654 91.2058 5.07654C92.8212 5.07654 94.4366 5.19193 96.1674 5.53807V7.615C94.3212 7.03808 92.5904 6.80731 91.3212 6.80731C89.7058 6.80731 88.552 7.26884 87.6289 8.07653C86.8212 8.88422 86.3597 10.1535 86.3597 11.6535C86.3597 13.1534 86.8212 14.3073 87.7443 15.2304C88.6674 16.0381 89.9366 16.4996 91.552 16.4996C93.052 16.4996 94.6674 16.1534 96.1674 15.5765L96.1674 17.4227Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.7461 17.8843L105.169 5.42273H108.515L113.938 17.8843H110.592L109.092 14.5381H103.323L101.823 17.8843H99.7461ZM104.131 12.9228H108.4L106.323 7.96122L104.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M135.861 17.8843L141.284 5.42273H144.631L150.054 17.8843H146.708L145.207 14.5381H139.438L137.938 17.8843H135.861ZM140.131 12.9228H144.4L142.207 7.96122L140.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M176.477 7.96119L178.669 12.9227H174.4L176.477 7.96119ZM175.554 5.42273L170.131 17.8843H172.208L173.708 14.5381H179.477L180.977 17.8843H184.323L178.9 5.42273H175.554Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M118.092 17.8843V5.42273H121.438L129.284 14.3074V5.42273H131.707V17.8843H128.592L120.515 8.53812V17.8843H118.092Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M154.092 17.8843V5.42273H160.092C162.284 5.42273 163.9 5.99965 165.053 6.92274C166.207 7.96119 166.784 9.46121 166.784 11.3074C166.784 13.3843 166.207 14.9997 164.938 16.0381C163.669 17.192 162.053 17.7689 159.861 17.7689H154.092L154.092 17.8843ZM156.976 16.1535H159.169C160.669 16.1535 161.823 15.8074 162.63 14.9997C163.438 14.192 163.784 13.1535 163.784 11.5381C163.784 10.3843 163.438 9.34581 162.861 8.53812C162.4 7.96119 161.938 7.61503 161.361 7.38427C160.784 7.1535 159.976 7.03811 158.823 7.03811H157.092V16.1535H156.976Z"
            })
        ]
    });

});

parcelRegister("bynL4", function(module, exports) {
$parcel$export(module.exports, "NasaLogo", function () { return $b07d7862f0c2a57d$export$e44efe2f415651b3; });

var $7VQPk = parcelRequire("7VQPk");
const $b07d7862f0c2a57d$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "88",
        height: "72",
        viewBox: "0 0 88 72",
        fill: "currentColor",
        role: "img",
        "aria-label": "NASA",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.4359 36C76.4359 55.7457 60.1693 71.9967 40.4025 71.9967C20.6364 71.9967 4.36914 55.7447 4.36914 36C4.36914 16.2532 20.256 0.0032959 40.4025 0.0032959C59.787 0.0032959 76.4359 16.2541 76.4359 36Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5289 54.9456C63.9235 61.2787 61.2524 45.2754 53.0462 33.0216C48.3951 26.0795 42.3294 20.2956 38.5036 17.5045C25.8183 8.24615 17.9873 13.8614 26.9449 32.1201C29.8412 38.0235 33.5609 42.0079 36.4663 45.7634C38.6851 48.6306 43.0069 50.0662 41.4845 51.426C39.7687 52.9603 35.6147 46.1937 35.6147 46.1937C32.5467 42.4938 29.6224 38.5457 26.6085 33.1273C19.723 20.7524 20.7158 8.12178 33.1799 13.6237C43.7574 18.2953 53.8606 31.3977 57.9232 40.7025C59.7991 44.9995 64.9144 61.9986 48.6221 55.1256",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.658203 46.6707C7.43066 42.1604 13.8517 39.2483 24.7788 35.6388C40.1336 30.5663 51.6898 27.1567 65.87 20.0294C72.2171 16.8399 83.23 9.68665 87.168 3.46851C85.9891 5.87521 82.3362 10.5597 80.6837 12.6312C61.4447 36.7206 20.464 35.3546 0.928637 46.9194"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.4824 29.0644C16.6807 29.113 16.0726 29.0519 16.145 29.1246C16.2532 29.1246 21.0941 37.461 21.0941 37.5334C21.0941 37.5686 21.0581 34.5706 21.0581 30.8208C21.0581 30.3878 19.8666 29.1249 19.9021 29.1249C21.6714 29.1249 23.9836 29.161 23.9836 29.161C23.1173 30.1715 22.9441 30.0881 22.9367 30.713C22.9123 32.7206 22.8897 36.4321 22.9367 40.6002C22.9435 41.2251 23.4064 41.4665 24.1652 42.5491H18.4931C16.6508 39.4818 13.2748 33.7275 13.2916 33.7443C13.3176 33.7706 13.2189 37.3537 13.327 40.2399C13.3634 41.1936 13.797 41.5028 14.5921 42.3694C14.5921 42.3694 15.5067 42.345 10.1484 42.4052C11.7741 41.5389 11.5581 40.4565 11.5574 40.4205C11.4991 36.4321 11.5452 33.0222 11.5452 30.8208C11.5452 30.46 11.5208 30.4957 10.4015 29.1246M29.8626 35.2239C30.383 33.417 30.8276 31.8024 31.0388 30.749C31.0745 30.5684 30.6415 29.9191 29.9552 29.2694L29.9066 29.1686C33.2163 29.1793 36.6739 29.1979 36.6739 29.1979C37.5771 31.3987 39.6358 37.5695 41.1893 41.3592C41.6 42.36 42.3093 42.5497 42.3093 42.5497C39.4916 42.514 34.2626 42.5384 34.2904 42.514C35.6988 41.2501 35.5182 41.2501 34.904 39.4112H30.4973C29.594 41.5037 30.7787 42.4859 30.9303 42.4782C29.9274 42.5302 26.5236 42.4782 26.5236 42.4782C28.3659 41.1783 28.2571 40.7817 28.2571 40.7817C28.7631 38.9812 29.3495 37.0087 29.8629 35.2236L31.671 35.2239L30.8942 37.7137H34.3992L32.4481 32.7334L31.6713 35.2233L29.8632 35.223M60.1359 35.4042C60.6554 33.5979 61.1003 31.9826 61.3115 30.9293C61.3469 30.749 60.9133 30.0997 60.2273 29.4494L60.1787 29.3492C63.4893 29.3599 66.9475 29.3782 66.9475 29.3782C67.8492 31.5796 69.9085 37.7498 71.4614 41.5395C71.8718 42.5415 72.5804 42.73 72.5804 42.73C69.7646 42.6943 64.5353 42.7187 64.5625 42.6943C65.9712 41.4313 65.7912 41.4313 65.177 39.5915H60.7694C59.8661 41.6843 61.0502 42.6662 61.2017 42.6591C60.1998 42.7105 56.7951 42.6591 56.7951 42.6591C58.6374 41.3598 58.5295 40.9626 58.5295 40.9626C59.0355 39.1615 59.6216 37.1899 60.1359 35.4042H61.9437C61.5544 36.65 61.1675 37.8949 61.1675 37.8949H64.6706L62.7195 32.914C62.7195 32.914 62.3324 34.1586 61.9437 35.4035L60.1359 35.4042ZM54.4372 32.4462C54.3654 29.8824 54.4372 29.0531 54.4372 29.0531C53.317 29.9558 53.8826 29.8406 51.0784 29.3779C42.9977 28.0447 42.382 35.5884 46.7795 37.2804C50.4709 38.7013 51.7784 38.98 51.2223 40.3114C51.0417 40.7459 47.6825 42.3331 44.2148 39.1209L44.2854 43.596C44.7193 43.1496 45.912 42.3331 45.912 42.3331C45.9471 42.3331 49.6706 43.9731 53.0276 42.261C58.194 39.6272 55.6155 35.3635 50.102 33.6725C45.5138 32.265 49.849 28.9807 54.4 32.4816M40.9091 3.27236C40.9089 3.35014 40.8779 3.42468 40.823 3.47974C40.768 3.5348 40.6936 3.56592 40.6158 3.56632C40.538 3.56584 40.4636 3.53469 40.4087 3.47965C40.3537 3.42461 40.3227 3.35011 40.3224 3.27236C40.3224 3.11284 40.4554 2.97961 40.6158 2.97961C40.6934 2.97986 40.7678 3.01076 40.8227 3.06559C40.8777 3.12042 40.9087 3.19473 40.9091 3.27236ZM42.9443 7.71602C42.9443 7.91404 42.7799 8.07752 42.5831 8.07752C42.4873 8.07712 42.3955 8.03891 42.3278 7.97122C42.26 7.90352 42.2218 7.8118 42.2213 7.71602C42.2213 7.51862 42.3844 7.35575 42.5831 7.35575C42.7802 7.35575 42.9443 7.51832 42.9443 7.71602ZM48.224 14.9783C48.224 15.1757 48.062 15.3392 47.8625 15.3392C47.7669 15.3386 47.6755 15.3003 47.6079 15.2328C47.5403 15.1653 47.502 15.0739 47.5013 14.9783C47.5013 14.7803 47.6526 14.6165 47.8515 14.6165C48.0507 14.6171 48.224 14.7803 48.224 14.9783ZM39.7357 10.2196C39.7354 10.2973 39.7044 10.3717 39.6494 10.4266C39.5945 10.4815 39.52 10.5124 39.4424 10.5126C39.3646 10.5124 39.2901 10.4815 39.2351 10.4266C39.18 10.3717 39.1489 10.2973 39.1484 10.2196C39.1484 10.0592 39.2813 9.92625 39.4424 9.92625C39.5201 9.92649 39.5946 9.95747 39.6495 10.0124C39.7045 10.0674 39.7355 10.1419 39.7357 10.2196ZM42.8984 11.889C42.8979 11.9665 42.8668 12.0407 42.812 12.0954C42.7571 12.1502 42.6829 12.1812 42.6054 12.1817C42.5278 12.1813 42.4535 12.1504 42.3985 12.0956C42.3435 12.0408 42.3124 11.9666 42.3117 11.889C42.3117 11.7285 42.4446 11.5959 42.6054 11.5959C42.7658 11.5959 42.8984 11.7285 42.8984 11.889ZM38.7884 7.21947C38.7884 7.41748 38.6253 7.58096 38.4273 7.58096C38.2292 7.58096 38.0661 7.4184 38.0661 7.21947C38.0661 7.02206 38.2292 6.85828 38.4273 6.85828C38.6253 6.85828 38.7884 7.02145 38.7884 7.21947ZM34.0031 10.1295C34.0031 10.2905 33.8708 10.4228 33.7095 10.4228C33.6318 10.4224 33.5574 10.3914 33.5025 10.3364C33.4476 10.2815 33.4165 10.2071 33.4161 10.1295C33.4161 9.96903 33.5487 9.8361 33.7095 9.8361C33.7872 9.83634 33.8617 9.86732 33.9168 9.92227C33.9718 9.97723 34.0028 10.0517 34.0031 10.1295ZM34.8587 10.7152C34.8584 10.7931 34.8274 10.8677 34.7723 10.9228C34.7172 10.9778 34.6427 11.0089 34.5648 11.0092C34.4869 11.0088 34.4124 10.9777 34.3574 10.9227C34.3023 10.8676 34.2712 10.7931 34.2708 10.7152C34.2743 10.6396 34.3068 10.5682 34.3615 10.5159C34.4163 10.4636 34.4891 10.4344 34.5648 10.4344C34.6405 10.4344 34.7133 10.4636 34.7681 10.5159C34.8228 10.5682 34.8553 10.6396 34.8587 10.7152ZM35.7174 11.3019C35.7172 11.3797 35.6862 11.4543 35.6313 11.5093C35.5763 11.5644 35.5018 11.5955 35.4241 11.5959C35.3463 11.5955 35.2717 11.5644 35.2168 11.5093C35.1618 11.4543 35.1307 11.3798 35.1304 11.3019C35.1304 11.1421 35.2633 11.0095 35.4241 11.0095C35.5851 11.0095 35.7174 11.1418 35.7174 11.3019ZM34.4096 12.4301C34.4088 12.5078 34.3775 12.582 34.3225 12.6369C34.2676 12.6918 34.1933 12.7228 34.1156 12.7235C34.0379 12.7231 33.9634 12.6921 33.9084 12.6372C33.8534 12.5822 33.8222 12.5079 33.8216 12.4301C33.8216 12.2697 33.9542 12.1371 34.1156 12.1371C34.276 12.1371 34.4096 12.2697 34.4096 12.4301ZM27.5903 17.2115C27.5899 17.2892 27.5587 17.3635 27.5036 17.4184C27.4486 17.4732 27.3741 17.504 27.2964 17.5042C27.1353 17.5042 27.0027 17.3722 27.0027 17.2115C27.0027 17.0507 27.1357 16.9178 27.2964 16.9178C27.4571 16.9178 27.5903 17.0504 27.5903 17.2115ZM28.8542 18.7457C28.8536 18.8234 28.8224 18.8976 28.7674 18.9525C28.7125 19.0073 28.6382 19.0383 28.5605 19.0388C28.4829 19.0383 28.4085 19.0073 28.3535 18.9525C28.2985 18.8977 28.2673 18.8234 28.2666 18.7457C28.2666 18.5844 28.3995 18.4524 28.5605 18.4524C28.7216 18.4524 28.8542 18.5844 28.8542 18.7457ZM27.8495 43.5111C27.849 43.5887 27.8179 43.6631 27.7629 43.718C27.7079 43.7728 27.6335 43.8038 27.5558 43.8041C27.3948 43.8041 27.2625 43.6715 27.2625 43.5111C27.2625 43.3506 27.3948 43.2174 27.5558 43.2174C27.7172 43.2174 27.8495 43.3506 27.8495 43.5111ZM28.0301 50.3434C28.0301 50.5414 27.8669 50.7046 27.6689 50.7046C27.4709 50.7046 27.3077 50.5423 27.3077 50.3434C27.3077 50.146 27.4709 49.9828 27.6689 49.9828C27.7644 49.9833 27.8559 50.0214 27.9235 50.0889C27.9911 50.1564 28.0294 50.2479 28.0301 50.3434ZM24.1459 53.8429C24.1453 53.9204 24.1143 53.9946 24.0594 54.0493C24.0046 54.1041 23.9304 54.1351 23.8529 54.1356C23.7753 54.1352 23.7009 54.1043 23.646 54.0495C23.591 53.9947 23.5598 53.9205 23.5592 53.8429C23.5592 53.6812 23.6921 53.5492 23.8529 53.5492C24.0133 53.5492 24.1459 53.6809 24.1459 53.8429ZM19.4957 55.2601C19.495 55.3558 19.4567 55.4474 19.389 55.515C19.3212 55.5826 19.2296 55.6208 19.1339 55.6213C19.0382 55.621 18.9465 55.5828 18.8788 55.5152C18.8112 55.4475 18.773 55.3558 18.7727 55.2601C18.7727 55.0624 18.9359 54.8989 19.1339 54.8989C19.2295 54.8995 19.3212 54.9377 19.3889 55.0053C19.4566 55.0729 19.4949 55.1644 19.4957 55.2601ZM18.5472 52.1038C18.5472 52.3009 18.384 52.4641 18.1866 52.4641C18.0911 52.4636 17.9996 52.4255 17.932 52.3581C17.8644 52.2907 17.8261 52.1993 17.8254 52.1038C17.8258 52.0081 17.8639 51.9163 17.9316 51.8485C17.9992 51.7808 18.0908 51.7424 18.1866 51.7417C18.384 51.7426 18.5472 51.9055 18.5472 52.1038ZM18.006 54.1115C18.006 54.2725 17.8731 54.4045 17.7123 54.4045C17.5516 54.4045 17.4184 54.2725 17.4184 54.1115C17.4184 53.9516 17.5516 53.8181 17.7123 53.8181C17.8731 53.8181 18.006 53.9507 18.006 54.1115ZM14.5282 52.4433C14.5278 52.5208 14.4968 52.5951 14.442 52.6499C14.3872 52.7047 14.313 52.7358 14.2355 52.7364C14.1578 52.736 14.0833 52.7051 14.0283 52.6502C13.9733 52.5954 13.9421 52.521 13.9415 52.4433C13.9415 52.2835 14.0742 52.1503 14.2355 52.1503C14.3956 52.1503 14.5282 52.2826 14.5282 52.4433ZM26.6748 58.0809C26.6748 58.2419 26.5535 58.3745 26.3931 58.3745C26.2321 58.3745 26.0878 58.2419 26.0878 58.0809C26.0878 57.9204 26.2208 57.7875 26.3812 57.7875C26.5428 57.7875 26.6748 57.9201 26.6748 58.0809ZM30.3332 55.3979C30.3332 55.5959 30.1816 55.7597 29.983 55.7597C29.785 55.7597 29.6108 55.5969 29.6108 55.3979C29.6108 55.2005 29.774 55.0373 29.972 55.0373C30.0675 55.0378 30.159 55.076 30.2267 55.1435C30.2943 55.211 30.3325 55.3024 30.3332 55.3979ZM30.7518 58.8479C30.7518 59.0089 30.6073 59.1421 30.4472 59.1421C30.3693 59.1417 30.2948 59.1105 30.2397 59.0554C30.1847 59.0003 30.1536 58.9257 30.1532 58.8479C30.1532 58.6881 30.2858 58.5554 30.4472 58.5554C30.6073 58.5551 30.7518 58.6871 30.7518 58.8479ZM45.7861 55.5538C45.7856 55.6313 45.7546 55.7056 45.6998 55.7605C45.6451 55.8154 45.5709 55.8466 45.4934 55.8474C45.4155 55.847 45.341 55.8159 45.2859 55.7609C45.2308 55.706 45.1995 55.6316 45.1988 55.5538C45.1988 55.3927 45.3314 55.2607 45.4934 55.2607C45.6535 55.2607 45.7861 55.3927 45.7861 55.5538ZM38.7884 58.0347C38.7881 58.1124 38.7571 58.1868 38.7021 58.2417C38.6472 58.2966 38.5728 58.3275 38.4951 58.3278C38.4175 58.3274 38.3431 58.2964 38.2882 58.2415C38.2333 58.1867 38.2022 58.1124 38.2017 58.0347C38.2017 57.8749 38.3347 57.7417 38.4951 57.7417C38.6564 57.7417 38.7884 57.8743 38.7884 58.0347ZM57.6183 61.6008C57.6176 61.6784 57.5865 61.7527 57.5315 61.8075C57.4766 61.8624 57.4022 61.8934 57.3246 61.8938C57.2469 61.8935 57.1724 61.8626 57.1173 61.8077C57.0622 61.7529 57.031 61.6785 57.0303 61.6008C57.0303 61.4407 57.1636 61.3077 57.3246 61.3077C57.485 61.3077 57.6183 61.4401 57.6183 61.6008ZM59.1519 47.728C59.1514 47.8238 59.1131 47.9154 59.0453 47.9831C58.9776 48.0508 58.8859 48.089 58.7901 48.0895C58.6945 48.0889 58.6028 48.0507 58.5352 47.983C58.4675 47.9153 58.4292 47.8237 58.4286 47.728C58.4286 47.53 58.5915 47.3665 58.7901 47.3665C58.8859 47.3669 58.9777 47.4051 59.0454 47.4728C59.1132 47.5405 59.1515 47.6322 59.1519 47.728ZM56.2643 49.6898C56.2637 49.7676 56.2325 49.8421 56.1774 49.897C56.1223 49.952 56.0478 49.983 55.97 49.9834C55.8099 49.9834 55.677 49.8505 55.677 49.6898C55.677 49.5291 55.8099 49.397 55.97 49.397C56.1313 49.397 56.2643 49.5288 56.2643 49.6898ZM59.1098 50.2551C59.1098 50.4528 58.9469 50.6169 58.748 50.6169C58.549 50.6169 58.3862 50.4537 58.3862 50.2551C58.3862 50.0577 58.549 49.8939 58.748 49.8939C58.9469 49.8939 59.1098 50.0577 59.1098 50.2551ZM56.2643 53.7509C56.2637 53.8286 56.2325 53.903 56.1774 53.9579C56.1223 54.0128 56.0478 54.0437 55.97 54.0439C55.8925 54.0434 55.8182 54.0123 55.7634 53.9575C55.7086 53.9026 55.6775 53.8284 55.677 53.7509C55.677 53.5898 55.8099 53.4572 55.97 53.4572C56.1313 53.4572 56.2643 53.5895 56.2643 53.7509ZM63.6225 45.7662C63.6225 45.9263 63.489 46.0596 63.3289 46.0596C63.2513 46.0589 63.1771 46.0278 63.1222 45.9729C63.0674 45.918 63.0364 45.8438 63.0358 45.7662C63.0358 45.6055 63.1684 45.4735 63.3289 45.4735C63.4893 45.4735 63.6225 45.6055 63.6225 45.7662ZM64.3345 47.5477C64.3345 47.7454 64.1839 47.9092 63.9849 47.9092C63.7866 47.9092 63.6121 47.7463 63.6121 47.5477C63.6121 47.3497 63.775 47.1868 63.973 47.1868C64.1716 47.1874 64.3345 47.3497 64.3345 47.5477ZM69.404 49.6684C69.404 49.8661 69.2426 50.0296 69.0425 50.0296C68.9467 50.0293 68.855 49.9911 68.7872 49.9235C68.7195 49.8558 68.6812 49.7641 68.6807 49.6684C68.6813 49.5726 68.7196 49.481 68.7873 49.4133C68.855 49.3456 68.9467 49.3074 69.0425 49.3069C69.1383 49.3072 69.23 49.3454 69.2978 49.4131C69.3655 49.4809 69.4037 49.5726 69.404 49.6684ZM64.2547 53.4364C64.254 53.5142 64.2227 53.5885 64.1677 53.6433C64.1126 53.6981 64.0382 53.7291 63.9605 53.7295C63.8828 53.7291 63.8085 53.6981 63.7535 53.6433C63.6985 53.5884 63.6674 53.5141 63.6668 53.4364C63.6668 53.2754 63.8001 53.1428 63.9605 53.1428C64.1209 53.1428 64.2547 53.2745 64.2547 53.4364ZM67.5064 50.3682C67.506 50.4458 67.475 50.5201 67.4201 50.5749C67.3652 50.6298 67.2909 50.6608 67.2133 50.6612C67.1357 50.6607 67.0614 50.6297 67.0065 50.5749C66.9516 50.52 66.9205 50.4458 66.92 50.3682C66.92 50.208 67.0535 50.0748 67.2133 50.0748C67.3737 50.0748 67.5064 50.2071 67.5064 50.3682ZM66.9074 55.1046C66.907 55.1822 66.876 55.2565 66.8212 55.3113C66.7663 55.3662 66.692 55.3972 66.6144 55.3976C66.5366 55.3975 66.462 55.3666 66.4069 55.3117C66.3518 55.2568 66.3206 55.1824 66.3201 55.1046C66.3201 54.9448 66.4527 54.8112 66.6144 54.8112C66.7748 54.8112 66.9074 54.9438 66.9074 55.1046ZM68.2856 47.233C68.2856 47.4808 68.0815 47.684 67.8336 47.684C67.5861 47.684 67.3823 47.4808 67.3823 47.233C67.3823 46.9854 67.5861 46.7822 67.8336 46.7822C68.0815 46.7822 68.2856 46.9854 68.2856 47.233Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.8322 45.8578L67.698 47.0981L66.4675 47.2338L67.7087 47.3682L67.8444 48.6544L67.9801 47.3682L69.1987 47.21L67.9691 47.0972L67.8322 45.8578ZM65.1223 55.0797C65.1223 55.3279 64.9185 55.5317 64.6707 55.5317C64.551 55.5312 64.4363 55.4834 64.3517 55.3988C64.267 55.3141 64.2192 55.1994 64.2188 55.0797C64.2188 54.8322 64.4229 54.629 64.6707 54.629C64.7902 54.6295 64.9046 54.6771 64.9892 54.7615C65.0738 54.8459 65.1216 54.9603 65.1223 55.0797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.6731 53.7047L64.5374 54.9457L63.3074 55.0804L64.5487 55.2161L64.6847 56.5011L64.8204 55.2161L66.0384 55.0578L64.8078 54.9448L64.6731 53.7047ZM31.4384 17.8199C31.4384 18.0674 31.2346 18.2709 30.9871 18.2709C30.8675 18.2706 30.7529 18.223 30.6682 18.1385C30.5835 18.054 30.5357 17.9395 30.5352 17.8199C30.5352 17.5717 30.7387 17.3685 30.9871 17.3685C31.2346 17.3691 31.4384 17.5723 31.4384 17.8199Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.9876 16.4441L30.8519 17.6845L29.6211 17.8201L30.863 17.9543L30.9986 19.2411L31.1337 17.9543L32.3529 17.7972L31.1221 17.6839L30.9876 16.4441ZM48.237 6.90409C48.237 7.15161 48.0329 7.35543 47.7851 7.35543C47.5373 7.35543 47.334 7.15161 47.334 6.90409C47.334 6.65597 47.5369 6.45215 47.7851 6.45215C48.0332 6.45215 48.237 6.65658 48.237 6.90409Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.7847 5.5271L47.6503 6.76834L46.42 6.90402L47.6616 7.03878L47.796 8.32464L47.9317 7.03878L49.1503 6.88049L47.9198 6.76773L47.7847 5.5271ZM27.8154 62.3008C27.8154 62.5489 27.6116 62.7521 27.3641 62.7521C27.2444 62.7517 27.1298 62.704 27.0451 62.6195C26.9605 62.535 26.9127 62.4204 26.9121 62.3008C26.9121 62.0536 27.1159 61.8491 27.3641 61.8491C27.6116 61.8494 27.8154 62.0539 27.8154 62.3008Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.3734 60.923L27.2384 62.1642L26.0078 62.2993L27.2494 62.434L27.3847 63.7199L27.5198 62.434L28.739 62.2764L27.5088 62.1633L27.3734 60.923Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.1638 3.46875C81.6723 19.7596 59.6743 32.3392 41.1564 44.3476C29.9849 51.595 18.8935 59.9362 11.2578 67.0335C9.24526 68.9052 11.6679 66.3335 10.8966 67.124C21.5526 54.8548 33.8104 47.5467 40.5841 42.9463C52.0398 35.1636 58.5556 33.2021 78.3195 14.9975"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M5.23755 43.8289C3.26537 44.7929 1.49884 45.746 0 46.6765L0.911835 47.0084C2.22275 46.2013 3.79646 45.3595 5.45421 44.6179M15.6491 62.0592C13.7728 63.6953 11.9275 65.3667 10.1142 67.0724L10.0317 68.3164C11.7429 66.5529 13.845 64.6501 16.2709 62.6303"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5295 54.9457C63.9241 61.2787 61.253 45.2755 53.0468 33.0216C48.3954 26.0796 42.6597 20.5725 38.5039 17.5045C33.6514 13.9217 33.1777 13.6246 33.1777 13.6246C44.014 18.7678 53.8584 31.3984 57.9204 40.7038C59.797 45.0005 64.912 61.9996 48.6193 55.1266",
                fill: "white"
            })
        ]
    });

});


parcelRegister("7chqp", function(module, exports) {
$parcel$export(module.exports, "HeroCards", function () { return $d73711ffa20ae17c$export$fd47e26e7f1281cb; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $iNnWi = parcelRequire("iNnWi");

var $6FYDc = parcelRequire("6FYDc");

var $6tzCE = parcelRequire("6tzCE");

var $3FT2j = parcelRequire("3FT2j");

var $b2wEL = parcelRequire("b2wEL");
const $d73711ffa20ae17c$export$fd47e26e7f1281cb = ()=>{
    const intl = (0, $8e22h.default)();
    const softwareCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-software-development-card.eyebrow-text",
            defaultMessage: "product & issue tracking"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-software-development-card.title-text",
            defaultMessage: "Software Development"
        }),
        image: (0, $iNnWi.getHeroCardSoftwareDevelopmentImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.OrangeCard),
        label: "software-development"
    };
    const marketingCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-marketing-card.eyebrow-text",
            defaultMessage: "plan & launch campaigns"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-marketing-card.title-text",
            defaultMessage: "Marketing"
        }),
        image: (0, $iNnWi.getHeroCardMarketingImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.PurpleCard),
        label: "marketing"
    };
    const itCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.updated-eyebrow-text",
            defaultMessage: "plan & track it projects"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.title-text",
            defaultMessage: "IT"
        }),
        image: (0, $iNnWi.getHeroCardItImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.GreenCard),
        label: "it"
    };
    const designCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-design-card.eyebrow-text",
            defaultMessage: "build creative workflows"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-design-card.title-text",
            defaultMessage: "Design"
        }),
        image: (0, $iNnWi.getHeroCardDesignImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.BlueCard),
        label: "design"
    };
    const operationsCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-operations-card.eyebrow-text",
            defaultMessage: "create custom processes"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-operations-card.title-text",
            defaultMessage: "Operations"
        }),
        image: (0, $iNnWi.getHeroCardOperationsImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.BlackCard),
        label: "operations"
    };
    const heroCardText = [
        softwareCard,
        marketingCard,
        itCard,
        designCard,
        operationsCard
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b2wEL.HeroContextProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1bsb1osq _p12f1ns9 _zulp7vkz _1reo1wug _12l21wug _ahbq1wug _ca0qvbgk _u5f319bv _n3td19bv _19bv19bv _a5o9coo4 _jzge1l27 _105s1y6m _2g9e19bv _1rwy1l7b _1w1e15zi _z6961l7b"
            ]),
            style: {
                "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800"))
            },
            children: [
                heroCardText.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6FYDc.HeroCard), {
                        eyebrow: card.eyebrow,
                        title: card.title,
                        image: card.image,
                        BackgroundImage: card.BackgroundImage,
                        idx: index,
                        label: card.label
                    }, index)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3FT2j.JswProductModalCarousel), {})
            ]
        })
    });
};
const $d73711ffa20ae17c$var$heroCardsStyling = null;

});
parcelRegister("6FYDc", function(module, exports) {
$parcel$export(module.exports, "HeroCard", function () { return $cd3457d7154b039d$export$57301f0520e516bf; });
/* hero-card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $b2wEL = parcelRequire("b2wEL");
const $cd3457d7154b039d$export$57301f0520e516bf = ({ eyebrow: eyebrow, title: title, image: image, BackgroundImage: BackgroundImage, idx: idx, label: label })=>{
    const { openModal: openModal } = (0, $b2wEL.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const handleClick = ()=>{
        openModal(idx);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `atlas-55799-${label}-modal-opened`,
                section: "hero-section"
            }
        }).fire();
    };
    const eyebrowText = intl.locale === "en" ? eyebrow : "";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: handleClick,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _y3gn1e5h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _2rkoqslr _c71l1kdj _1ul9gx0z _11q7cd5j _16qst7xp _80omtlke _v564188d _1reozryt _18m9zryt _1i7qgx0z _5jif1dft _1ii3130s _hzy51qv5 _1lsjkb7n _c1lpkb7n _mlnj1xcn _1y8o122m _123rnklw"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bozg1u1b"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1hlo _ect41qje _1wyb1crf _k48p1nn1 _vwz47vkz _1dyz1wr8 _1p1dangw _1q511pa9 _3fcw1q9c _1bysw1gv _1rfmn6wy"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bsbzdsj _syaz1hlo _ect41qje _1wyb1tcg _k48p1fw0 _vwz41ul9 _1q511v6z _slp31hna _ct361wug _1bah1yb4 _zzrmn6wy _1gdl1oqx _1p1d1tcg _1r3wgktf _ui901hlo _1jw8ni7l _1bys1f4h"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _18m9zryt _c71l1kdj"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)(BackgroundImage, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_2rkoqslr _15801u1b _f45rstnw _dgw6idpf _1hlvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: image,
                                width: 227,
                                height: 364,
                                alt: "",
                                loading: "eager"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $cd3457d7154b039d$var$cardStyles = null;
const $cd3457d7154b039d$var$textStyles = null;
const $cd3457d7154b039d$var$eyebrowStyles = null;
const $cd3457d7154b039d$var$titleStyles = null;
const $cd3457d7154b039d$var$imageContainer = null;
const $cd3457d7154b039d$var$pictureStyles = null;

});
parcelRegister("b2wEL", function(module, exports) {
$parcel$export(module.exports, "useHeroState", function () { return $2f6af509606af537$export$e2b31be5fe4d64c8; });
$parcel$export(module.exports, "HeroContextProvider", function () { return $2f6af509606af537$export$b1ebf81440d0ff8d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $2f6af509606af537$var$initVal = {
    modalIndex: -1,
    closeModal: ()=>-1,
    openModal: ()=>0
};
const $2f6af509606af537$export$63ebd153bf781d5f = /*#__PURE__*/ (0, $1oC0p.createContext)($2f6af509606af537$var$initVal);
const $2f6af509606af537$export$e2b31be5fe4d64c8 = ()=>{
    return (0, $1oC0p.useContext)($2f6af509606af537$export$63ebd153bf781d5f);
};
const $2f6af509606af537$export$b1ebf81440d0ff8d = ({ children: children })=>{
    const [modalIndex, setModalIndex] = (0, $1oC0p.useState)(-1);
    const openModal = (num)=>setModalIndex(num);
    const closeModal = ()=>setModalIndex(-1);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($2f6af509606af537$export$63ebd153bf781d5f.Provider, {
        value: {
            modalIndex: modalIndex,
            openModal: openModal,
            closeModal: closeModal
        },
        children: children
    });
};

});


parcelRegister("6tzCE", function(module, exports) {
$parcel$export(module.exports, "OrangeCard", function () { return $ff9b5386d1e37ddf$export$b9f0637fcee76583; });
$parcel$export(module.exports, "PurpleCard", function () { return $ff9b5386d1e37ddf$export$265c26304bb77354; });
$parcel$export(module.exports, "GreenCard", function () { return $ff9b5386d1e37ddf$export$961a018b253e0f90; });
$parcel$export(module.exports, "BlueCard", function () { return $ff9b5386d1e37ddf$export$294f4b24111c26a1; });
$parcel$export(module.exports, "BlackCard", function () { return $ff9b5386d1e37ddf$export$89725581676ad6dc; });

var $7VQPk = parcelRequire("7VQPk");
const $ff9b5386d1e37ddf$export$b9f0637fcee76583 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 392",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190 10.1105L287 0.5V551.5H190V10.1105Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "309.5",
                width: "72",
                height: "242",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 174L242 93.5V551.5H33.7079L12 174Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.3757 345.607C94.4326 316.532 72.821 353.827 66.5766 359.591C66.6744 349.361 70.2219 339.822 71.6661 329.54C71.4521 329.774 71.4286 329.07 71.6094 328.451C73.7067 306.146 55.5882 335.822 52.852 342.965C52.8571 342.947 53.3076 341.612 53.3161 341.582C31.2979 381.303 52.5372 327.158 50.7712 312.8C48.0114 301.66 39.0231 319.691 36.7403 323.74C31.7817 332.292 13.1954 371.804 21.3158 339.578L21.2302 339.793L21.2235 339.686C19.9412 343.752 15.1863 361.553 23.3964 349.43C10.382 367.677 25.8305 321.339 26.8121 316.021C26.1187 322.416 23.5003 329.295 23.3121 331.581C41.6247 260.152 8.32378 331.528 -3.15113 344.753C-3.42866 340.861 -2.2046 336.52 -1.45501 332.791C-1.98174 333.871 -3.12206 341.129 -3.73261 342.354C-3.72327 338.625 1.46654 318.867 -0.581947 328.733C-0.457885 325.429 13.7951 290.239 0.489425 297.317C-9.28835 307.87 -13.5004 323.636 -23.888 333.64C-27.6163 327.225 -8.20945 290.969 -22.1535 295.019C-27.7263 298.074 -47.3766 333.181 -43.7036 312.264C-42.1393 303.197 -44.4527 311.487 -45.0251 315.266C-45.0595 314.841 -45.0769 314.422 -45.0925 313.996C-47.299 337.542 -24.8339 295.427 -19.3444 295.729C-19.8045 309.234 -37.4438 360.038 -12.0674 320.742C-12.162 320.968 -12.767 322.392 -12.8497 322.576C-9.19942 319.69 -2.36649 297.801 4.10625 299.033C4.95454 300.683 2.22361 313.34 3.286 305.572C-18.0291 379.053 3.4966 342.697 25.4581 304.882C28.5782 319.533 11.6245 341.427 18.0739 356.474C32.5546 349.034 35.4669 325.194 47.1207 313.346C48.9171 319.068 44.6492 329.85 43.4684 336.596L43.6763 336.143C36.233 364.657 39.9023 372.572 56.209 341.886C58.3648 338.768 71.6989 313.331 68.9071 329.746C59.4974 378.571 64.4338 364.369 88.6115 336.779C92.4748 337.752 87.4444 359.722 91.3626 345.61L91.3757 345.607Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$265c26304bb77354 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 391",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190 88.1977L287 80V550H190V88.1977Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "245",
                width: "72",
                height: "305",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.5 0L261 16V550H35.5011L18.5 0Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.3957 245.058C33.5425 244.959 48.888 241.246 44.8628 240.44C43.3696 240.859 42.2092 240.436 41.4627 241.57C41.2468 240.233 38.3189 242.367 37.8691 242.448C37.6668 241.435 33.0793 244.041 33.7494 243.1C31.6671 243.127 29.081 243.856 26.3915 244.712C25.0737 243.816 30.7226 237.425 28.3479 238.807C28.5143 238.446 29.153 236.889 29.0675 237.92C29.8186 237.038 37.9951 223.535 34.595 225.822C32.3012 228.608 30.5787 233.275 28.6358 235.58C26.7468 236.358 25.438 243.046 23.3332 242.38C22.1054 240.877 18.9391 222.469 16.6904 224.103C17.0817 225.534 16.7264 226.816 17.8193 227.505C16.4835 227.721 18.6153 230.651 18.6963 231.101C17.7068 231.29 20.2704 235.899 19.3484 235.224C19.3664 236.525 19.6587 238.028 20.0815 239.626C19.5193 239.198 18.9032 238.221 18.5479 238.077C14.761 236.543 11.8915 233.014 7.94723 231.101C4.63257 235.327 33.9428 245.99 15.7684 247.583C12.3503 249.815 7.8078 250.157 3.99392 252.304C3.6656 256.954 25.4066 244.126 19.1325 251.494C18.1566 254.609 16.7084 258.106 14.707 261.175C13.4297 272.882 24.2912 241.079 23.8414 253.213C25.3391 256.112 26.7873 259.605 27.5294 263.201C32.8409 270.996 25.591 250.374 24.8309 247.453C27.7093 246.224 38.8361 260.158 40.851 257.962C40.9454 257.651 39.3443 255.927 38.8586 255.743C38.5303 255.909 38.3639 256.044 38.1705 255.738C39.1464 254.798 35.7238 253.61 35.4 253.286C36.1196 252.57 31.3568 250.243 32.5126 250.279C31.6221 249.032 30.2594 247.777 28.7077 246.512C31.4602 245.981 32.6565 244.036 32.4047 245.049L32.3957 245.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$961a018b253e0f90 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 409",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.9004 26.5L287.4 0.5V569H119.4L75.9004 26.5Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-5.59961 311L67.4004 286L72.4004 568.5H0.400391L-5.59961 311Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.40039 151L242.4 110.5V568.5H34.1083L21.4004 352L9.40039 151Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.8986 132.781C39.2166 132.221 36.9442 123.743 35.8543 126.325C35.3391 127.211 35.4683 127.971 36.3627 128.134C34.6953 128.569 37.0904 129.969 36.6079 130.815C35.405 130.663 38.0687 132.76 36.8029 132.437C36.3425 141.913 49.4139 159.478 40.5422 137.288C40.2112 139.625 39.5574 137.525 39.7288 136.473C41.3639 137.777 39.6836 133.639 39.0942 132.906C39.2394 134.228 37.9371 132.161 38.895 132.785L38.8986 132.781Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.0831 151.179C25.9033 149.969 17.1793 145.733 16.3356 145.174C14.3049 144.321 14.3929 147.139 16.0855 147.422C16.3879 147.621 18.8106 148.168 17.851 148.841C18.5768 151.171 22.8129 151.064 23.2479 153.049C23.7743 152.669 24.4966 153.313 24.8533 153.111C24.8407 153.717 25.6701 153.967 25.7296 153.816C28.0241 156.156 30.1997 152.73 27.1018 151.667C27.2204 151.551 26.6349 150.91 26.0911 151.178L26.0831 151.179Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.214 183.803C14.6822 184.753 13.2253 184.829 12.5136 184.357C13.6609 183.246 10.784 183.546 10.075 183.952C10.379 183.982 10.4712 184.496 9.84193 184.471C10.3094 183.168 2.35086 182.948 6.04574 185.633C6.18193 185.627 6.26697 184.6 6.41885 184.919C6.11372 186.476 7.39131 185.384 7.74683 185.263C7.71942 186.071 8.07319 185.319 8.154 185.653C7.69634 186.742 9.77517 184.913 9.26035 185.992C11.045 187.634 14.7083 185.435 16.0664 186.932C17.0725 185.111 22.8461 187.798 20.677 184.338C18.1787 183.565 16.1276 183.133 13.214 183.803Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-1.49997 165.314C-2.19099 167.811 3.30413 167.242 4.76979 168.257C6.53807 169.708 25.7928 174.672 20.8767 169.788C15.0359 168.335 10.5165 166.116 3.19864 165.256C2.02145 165.029 -1.61684 163.57 -1.49997 165.314Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.4411 142.901C59.4435 144.317 56.8745 146.385 58.5173 147.732C61.6811 149.754 63.1253 131.281 59.8252 131.898C57.053 132.811 58.6706 141.577 57.4411 142.901Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$294f4b24111c26a1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 399",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "-0.199219",
                y: "280",
                width: "72",
                height: "278",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.8008 138.97L241.801 109V558H33.5086L11.8008 138.97Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M90.8008 21.5233L280.801 0.5L286.801 558H90.8008V21.5233Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.8008 315.386C53.0837 310.928 56.2763 303.048 51.8894 298.79C43.0193 295.942 41.3834 312.505 35.5983 314.656C32.9661 310.471 35.7511 304.135 32.4397 299.771C32.5982 299.877 33.1077 300.429 33.1643 300.501C24.464 290.96 21.5771 313.413 14.9939 314.74C12.2316 310.148 16.8959 297.698 8.42202 298.227C3.07847 298.305 -3.06324 320.558 -6.14824 312.979L-6.15955 313.085L-6.19918 313.046C-5.89917 318.446 -1.16129 312.449 -0.312218 310.755C-7.56903 324.119 -7.16713 307.244 -7.90866 301.114C-6.45956 302.736 -7.05958 307.188 -6.56711 309.106C-6.63504 285.705 -18.9581 306.263 -24.5846 314.506C-28.5753 314.305 -25.6828 304.787 -27.4545 301.66C-27.3526 302.329 -26.6847 306.113 -27.3413 306.849C-27.5168 304.079 -27.3583 298.222 -31.666 298.929C-31.2244 298.021 -29.0621 298.929 -28.813 299.347C-37.836 295.084 -39.0303 313.202 -46.089 314.79C-48.1438 310.075 -45.54 304.045 -48.4155 299.403C-56.7761 290.498 -65.867 327.608 -67.401 309.49C-67.8708 305.834 -66.5066 299.431 -71.1992 298.801C-70.4577 299.23 -68.7992 300.384 -68.8897 302.179C-69.0143 301.989 -69.1331 301.8 -69.2577 301.621C-67.984 306.397 -70.1294 311.513 -67.8595 316.01C-61.9669 321.533 -56.0403 297.86 -50.0684 300.228C-47.6117 303.293 -49.3722 308.353 -48.7495 312.02C-48.7948 311.903 -49.0212 311.145 -49.0608 311.045C-47.4249 328.622 -35.8887 303.388 -37.0152 307.149C-22.5185 284.546 -36.5567 329.725 -20.8487 314.974C-17.1467 311.914 -14.8711 300.172 -9.98608 301.738C-9.32946 307.79 -9.0068 325.211 0.0557327 313.943C3.46905 310.17 4.82756 302.151 9.87677 301.036C12.5542 305.767 8.05408 322.286 18.4412 316.936C18.3393 316.975 18.2431 317.019 18.1355 317.058C22.347 315.609 26.632 296.137 31.0472 302.006C32.751 305.818 29.5415 316.791 36.1077 317.119C41.8532 316.646 47.7289 292.587 51.7761 303.522C52.512 306.13 52.1837 317.654 55.7894 315.37L55.8008 315.386Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$89725581676ad6dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 428",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.199 46.1105L287.199 36.5V587.5H190.199V46.1105Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "0.199219",
                y: "345.5",
                width: "72",
                height: "242",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.1992 210L242.199 129.5V587.5H33.9071L12.1992 210Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M264.513 26.5943C264.532 26.5625 264.532 26.5053 264.57 26.4609C263.451 25.9017 263.323 24.5292 262.46 23.7096L262.428 23.6778C261.552 23.3982 261.789 22.5277 260.702 22.5213C260.702 22.5213 260.983 22.3815 260.99 22.3815C259.225 20.6405 254.864 16.3642 254.864 16.3642C254.768 16.7518 255.561 16.0782 256.36 16.1926C256.36 16.1926 256.418 16.0465 256.475 16.1609C258.515 14.1848 260.811 13.4286 263.419 12.4882C264.724 12.1387 264.922 8.47237 262.69 9.991C262.665 9.96558 262.607 9.94659 262.582 9.90211C261.802 10.8044 260.504 10.4739 259.519 10.9441L259.481 10.9632L257.844 11.7575C256.955 12.1196 255.9 12.4056 254.794 12.6852C254.826 12.6534 254.858 12.6217 254.89 12.5899C254.89 12.5899 255.005 10.8298 254.973 9.95927C254.973 9.95927 256.092 8.5614 255.721 7.60193C256.354 6.47725 258.605 4.01814 256.559 3.31919C255.887 3.31919 255.363 2.74099 255.133 3.81483C255.094 3.80848 255.043 3.82117 254.992 3.80211C254.871 4.91408 253.547 5.702 253.183 6.75678L253.17 6.8013C253.259 7.70359 252.556 8.59313 252.55 8.59313C252.217 9.41916 251.782 10.3214 251.322 11.2618C251.13 10.7535 250.919 10.3024 250.708 9.97836C249.941 9.15232 250.267 -2.13257 247.428 0.358238C247.563 2.48686 248.24 4.70441 247.69 6.59793C247.422 6.74407 247.831 7.50022 248.164 8.11657C248.138 8.89812 247.978 9.31751 247.933 10.4358C246.527 9.42553 240.389 4.3105 240.766 7.75442C241.424 8.1039 241.904 8.50418 242.249 9.3175C242.569 9.66698 245.389 11.2428 245.478 11.6368C245.293 12.1832 248.624 12.6216 247.275 13.0283C247.473 13.4604 247.742 13.8734 248.055 14.2737C246.597 14.4262 244.852 14.8519 243.937 15.4047C243.777 15.6779 237.959 16.0465 235.849 17.3999C234.589 18.1052 233.477 18.4547 234.788 19.5159C235.261 19.1346 237.038 19.6811 237 19.1791C237.435 19.357 240.376 18.2386 240.702 18.4293C240.862 18.6834 243.176 17.3364 242.901 17.9718C244.506 18.4229 246.463 18.0544 248.496 17.5397C247.69 18.8105 246.898 20.6214 246.795 21.7461C246.105 23.1885 244.282 26.3783 243.701 28.3354C242.869 29.7587 243.157 29.873 244.206 30.6037L244.225 30.6228C244.442 30.769 244.199 30.6228 245.024 30.6545C244.941 30.5783 244.82 30.2479 244.66 30.3051C244.768 30.0827 246.022 29.765 245.497 29.4663C245.478 29.4219 246.297 28.7992 246.38 28.1256C247.109 25.7238 248.854 24.5101 250.146 21.7715C250.114 22.0575 252.288 27.4394 252.185 30.1208C252.025 31.4425 255.248 33.4123 254.781 30.464C254.82 30.4513 254.851 30.4004 254.909 30.3941C254.391 29.1805 255.075 27.9286 254.807 26.696L254.794 26.6451C254.212 25.8954 254.883 25.2727 253.963 24.6627C253.963 24.6627 254.276 24.6944 254.282 24.7008C253.873 22.9534 253.617 20.8184 253.234 18.9058C254.609 20.1449 255.817 21.4792 256.316 22.947L256.38 22.8518C256.38 22.8962 256.475 22.928 256.392 23.0296C257.55 23.2711 257.946 23.754 258.784 24.0781C258.784 24.0781 259.679 25.6857 260.721 25.7428L262.307 27.9731C262.991 29.1232 266.68 28.4624 264.538 26.6197L264.513 26.5943Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("3FT2j", function(module, exports) {
$parcel$export(module.exports, "JswProductModalCarousel", function () { return $3148b6359fff8134$export$e7364013ca7b67b5; });
/* product-modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lfTOg = parcelRequire("lfTOg");

var $gNuc8 = parcelRequire("gNuc8");

var $eMDDH = parcelRequire("eMDDH");

var $cB1fn = parcelRequire("cB1fn");

var $6ED9p = parcelRequire("6ED9p");

var $g0VYP = parcelRequire("g0VYP");

var $2YpfC = parcelRequire("2YpfC");

var $5WMok = parcelRequire("5WMok");

var $dTWad = parcelRequire("dTWad");

var $bVodu = parcelRequire("bVodu");

var $l6HGO = parcelRequire("l6HGO");

var $04laP = parcelRequire("04laP");

var $jQ0cd = parcelRequire("jQ0cd");

var $6Ro48 = parcelRequire("6Ro48");

var $iNnWi = parcelRequire("iNnWi");

var $6RoNo = parcelRequire("6RoNo");

var $b97hj = parcelRequire("b97hj");

var $ktT4l = parcelRequire("ktT4l");

var $b2wEL = parcelRequire("b2wEL");
const $3148b6359fff8134$export$e7364013ca7b67b5 = ()=>{
    const { modalIndex: modalIndex } = (0, $b2wEL.useHeroState)();
    const intl = (0, $8e22h.default)();
    // Disable scroll if modal is open
    (0, $1oC0p.useEffect)(()=>{
        if (modalIndex !== -1) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
    }, [
        modalIndex
    ]);
    const softwareModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.eyebrow-text",
            defaultMessage: "product and issue tracking"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.title-text",
            defaultMessage: "Software Development"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.description-text",
            defaultMessage: "Plan, track, release and support world-class software. Jira is the single source of truth for your entire development lifecycle."
        }),
        image: (0, $iNnWi.getProductSoftwareDevelopmentModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gNuc8))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-analytics.icon-text",
                    defaultMessage: "Analytics"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04laP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-sprint-planning.icon-text",
                    defaultMessage: "Sprint planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VYP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.OrangeModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=software-development"),
        label: "software-development",
        personaData: {
            team: "Software Development",
            persona: "Software Development Generic"
        }
    };
    const marketingModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.eyebrow-text",
            defaultMessage: "plan and launch campaigns"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.title-text",
            defaultMessage: "Marketing"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.description-text",
            defaultMessage: "Make launching viral marketing campaigns a breeze. Break down complex campaigns into actionable steps, easily collect requests, and stay aligned with cross-functional teams."
        }),
        image: (0, $iNnWi.getProductMarketingModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-calendar-view.icon-text",
                    defaultMessage: "Calendar view"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VYP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-forms.icon-text",
                    defaultMessage: "Forms"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.PurpleModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).CampaignManagement}`),
        label: "marketing",
        personaData: {
            team: "Marketing",
            persona: "Marketing Generic"
        }
    };
    const itModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.updated-eyebrow-text",
            defaultMessage: "plan and track it projects"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.title-text",
            defaultMessage: "IT support services"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.updated-description-text",
            defaultMessage: "Streamline IT projects and deliver reliable services to internal teams, from migration management to software deployment. Gain visibility across IT workflows to align technology projects to business goals."
        }),
        image: (0, $iNnWi.getUpdatedProductItModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-resolve-incidents.updated-icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVodu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-help-desk.updated-icon-text",
                    defaultMessage: "Intake requests"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5WMok))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-manage-requests.updated-icon-text",
                    defaultMessage: "Release management"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eMDDH))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.GreenModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=it"),
        label: "it",
        personaData: {
            team: "IT Support",
            persona: "IT Support Generic"
        }
    };
    const designModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.eyebrow-text",
            defaultMessage: "build creative workflows"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.title-text",
            defaultMessage: "Design"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.description-text",
            defaultMessage: "Collaborate on, organize, and deliver creative requests with ease. Give real-time visibility into designs with Jira\u2019s Figma integration and accelerate approvals."
        }),
        image: (0, $iNnWi.getProductDesignModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-task-planning.icon-text",
                    defaultMessage: "Task planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YpfC))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVodu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-prioritization.icon-text",
                    defaultMessage: "Prioritization"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.BlueModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).WebDesignProcess}`),
        label: "design",
        personaData: {
            team: "Design",
            persona: "Design Generic"
        }
    };
    const operationsModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.eyebrow-text",
            defaultMessage: "create intake processes"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.title-text",
            defaultMessage: "Operations"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.description-text",
            defaultMessage: "Manage procurement, office, and new vendor requests, craft new operational processes, monitor operational risks and more. Keep your company running at maximum efficiency with Jira."
        }),
        image: (0, $iNnWi.getProductOperationsModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-task-planning.icon-text",
                    defaultMessage: "Task planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6HGO))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-prioritization.icon-text",
                    defaultMessage: "Prioritization"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VYP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.BlackModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).SimplifiedProcessControl}`),
        label: "operations",
        personaData: {
            team: "Operations",
            persona: "Operations Generic"
        }
    };
    const JswProductTourModalCards = [
        softwareModal,
        marketingModal,
        itModal,
        designModal,
        operationsModal
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: modalIndex !== -1 && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b97hj.ProductModalCarousel), {
                    children: JswProductTourModalCards.map((props, idx)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ktT4l.ProductModalCard), {
                            ...props
                        }, idx);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _je3oglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ktT4l.ProductModalCard), {
                        ...JswProductTourModalCards[modalIndex]
                    })
                })
            ]
        })
    });
};
const $3148b6359fff8134$var$modalBackgroundStyles = null;

});
parcelRegister("g0VYP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb53df8812f428ed0814030a719aff1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba899f0dcb8b83d9$var$_react = $ba899f0dcb8b83d9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ba899f0dcb8b83d9$var$_baseNew = $ba899f0dcb8b83d9$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ba899f0dcb8b83d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba899f0dcb8b83d9$var$MenuIcon = (props)=>/*#__PURE__*/ $ba899f0dcb8b83d9$var$_react.default.createElement($ba899f0dcb8b83d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$ba899f0dcb8b83d9$var$MenuIcon.displayName = 'MenuIcon';
var $ba899f0dcb8b83d9$var$_default = module.exports.default = $ba899f0dcb8b83d9$var$MenuIcon;

});

parcelRegister("bVodu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17ddc348c6f916127485ad6ca25becea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ae7cd7e072e93b9$var$_react = $8ae7cd7e072e93b9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8ae7cd7e072e93b9$var$_baseNew = $8ae7cd7e072e93b9$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8ae7cd7e072e93b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ae7cd7e072e93b9$var$SendIcon = (props)=>/*#__PURE__*/ $8ae7cd7e072e93b9$var$_react.default.createElement($8ae7cd7e072e93b9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$8ae7cd7e072e93b9$var$SendIcon.displayName = 'SendIcon';
var $8ae7cd7e072e93b9$var$_default = module.exports.default = $8ae7cd7e072e93b9$var$SendIcon;

});

parcelRegister("04laP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9875595fe1109f3e22750943d295221a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00d0cc79bda24e44$var$_react = $00d0cc79bda24e44$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $00d0cc79bda24e44$var$_baseNew = $00d0cc79bda24e44$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $00d0cc79bda24e44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00d0cc79bda24e44$var$TasksIcon = (props)=>/*#__PURE__*/ $00d0cc79bda24e44$var$_react.default.createElement($00d0cc79bda24e44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm6.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L6 8.086z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$00d0cc79bda24e44$var$TasksIcon.displayName = 'TasksIcon';
var $00d0cc79bda24e44$var$_default = module.exports.default = $00d0cc79bda24e44$var$TasksIcon;

});

parcelRegister("6Ro48", function(module, exports) {
$parcel$export(module.exports, "TemplateKey", function () { return $3bde895dc42da213$export$21f5be7276c6a79d; });
var $3bde895dc42da213$export$21f5be7276c6a79d = /*#__PURE__*/ function(TemplateKey) {
    TemplateKey["SimplifiedBasic"] = "com.pyxis.greenhopper.jira:gh-simplified-basic";
    TemplateKey["Scrum"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum";
    TemplateKey["Kanban"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban";
    TemplateKey["WebDesignProcess"] = "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process";
    TemplateKey["GoToMarket"] = "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market";
    TemplateKey["SimplifiedProcessControl"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control";
    TemplateKey["ProcessControlTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed";
    TemplateKey["SalesPipeline"] = "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline";
    TemplateKey["SimplifiedProcurement"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement";
    TemplateKey["EmployeeOnboarding"] = "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding";
    TemplateKey["PersonalTaskPlanner"] = "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner";
    TemplateKey["CampaignManagement"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management";
    TemplateKey["CampaignManagementTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed";
    TemplateKey["CampaignManagementV2TeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed-v2";
    TemplateKey["Recruitment"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment";
    TemplateKey["RecruitmentTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed";
    TemplateKey["LeadTracking"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking";
    TemplateKey["LeadTrackingTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed";
    TemplateKey["MonthEndClose"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close";
    TemplateKey["MonthEndCloseTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close-team-managed";
    return TemplateKey;
}({});

});

parcelRegister("6RoNo", function(module, exports) {
$parcel$export(module.exports, "OrangeModal", function () { return $6ebf3ce23ce1ed11$export$6c8874c44e988ef8; });
$parcel$export(module.exports, "PurpleModal", function () { return $6ebf3ce23ce1ed11$export$fd3dd56b06272778; });
$parcel$export(module.exports, "GreenModal", function () { return $6ebf3ce23ce1ed11$export$4e38f8e127b6b98b; });
$parcel$export(module.exports, "BlueModal", function () { return $6ebf3ce23ce1ed11$export$f4813b8b24b3c6ba; });
$parcel$export(module.exports, "BlackModal", function () { return $6ebf3ce23ce1ed11$export$523a506d2ef0ae23; });

var $7VQPk = parcelRequire("7VQPk");
const $6ebf3ce23ce1ed11$export$6c8874c44e988ef8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 757 491",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M356 15.3286L756.5 0.5L743 448H356V15.3286Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43 232.398L388 184V470L52.2992 459.355L43 232.398Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M130.234 460.03C140.887 430.441 107.574 463.703 99.1998 468.074C101.862 457.404 108.184 448.371 112.355 438.004C112.058 438.192 112.208 437.45 112.563 436.851C120.461 414.086 92.9297 440.308 88.1073 447.052C88.1175 447.034 88.951 445.758 88.968 445.729C54.5977 481.419 91.7038 430.441 93.3267 414.961C93.0425 402.582 78.5587 419.05 75.0123 422.678C67.3702 430.305 36.8636 466.687 53.9276 435.147L53.7787 435.35L53.798 435.236C51.3589 439.146 41.6341 456.497 53.7788 446C34.7693 461.626 63.4948 417.275 65.9126 411.975C63.5461 418.477 58.9206 424.975 58.1411 427.315C96.3111 357.491 41.5077 423.285 25.4617 434.069C26.1251 429.926 28.5681 425.713 30.3316 422.012C29.4769 423.002 26.3986 430.288 25.4147 431.407C26.3559 427.511 37.0523 408.23 32.3143 418.001C33.277 414.579 57.8915 381.568 41.3467 385.439C27.8528 393.88 19.2388 409.247 5.2045 416.952C2.66538 409.255 33.2703 376.495 16.7724 377.032C9.82032 378.748 -20.7683 410.243 -11.4671 389.347C-7.46621 380.282 -12.1051 388.336 -13.6843 392.136C-13.6164 391.682 -13.531 391.239 -13.4422 390.79C-21.7707 414.823 13.6935 376.748 19.715 378.519C15.8326 392.517 -16.441 440.957 21.5529 406.601C21.3914 406.812 20.3641 408.14 20.2264 408.31C25.0007 406.262 38.054 385.188 44.9353 388.193C45.4657 390.142 39.2729 402.652 42.3922 394.811C0.374836 465.986 33.3582 433.682 67.1895 399.97C66.9974 416.115 42.7024 434.51 46.1091 451.952C64.0492 448.014 73.2351 423.861 89.1359 414.564C89.7026 421.023 82.271 431.164 79.2755 437.904L79.6195 437.485C64.2344 465.324 66.334 474.572 92.1053 446.813C95.2779 444.125 116.437 421.066 109.239 437.488C86.5994 486.04 95.6274 472.501 129.368 450.066C133.416 452.108 122.344 473.745 130.219 460.029L130.234 460.03Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$fd3dd56b06272778 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 729 447",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M453 6.8593L729 0V325H453V6.8593Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21 229.336L218 185V447L26.31 437.248L21 229.336Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.471 195.058C29.6205 194.959 45.0014 191.246 40.9669 190.44C39.4702 190.859 38.3072 190.436 37.5589 191.57C37.3425 190.233 34.4079 192.367 33.9571 192.448C33.7542 191.435 29.1562 194.041 29.8279 193.1C27.7407 193.127 25.1487 193.856 22.453 194.712C21.1322 193.816 26.7941 187.425 24.4139 188.807C24.5807 188.446 25.2208 186.889 25.1352 187.92C25.888 187.038 34.0833 173.535 30.6754 175.822C28.3763 178.608 26.6498 183.275 24.7024 185.58C22.8091 186.358 21.4973 193.046 19.3876 192.38C18.1569 190.877 14.9834 172.469 12.7295 174.103C13.1216 175.534 12.7655 176.816 13.8609 177.505C12.5221 177.721 14.6588 180.651 14.74 181.101C13.7482 181.29 16.3177 185.899 15.3936 185.224C15.4117 186.525 15.7047 188.028 16.1284 189.626C15.5649 189.198 14.9473 188.221 14.5912 188.077C10.7956 186.543 7.91954 183.014 3.96613 181.101C0.643816 185.327 30.0217 195.99 11.8053 197.583C8.37936 199.815 3.82638 200.157 0.0036926 202.304C-0.325383 206.954 21.4657 194.126 15.1772 201.494C14.199 204.609 12.7475 208.106 10.7415 211.175C9.46124 222.882 20.3478 191.079 19.897 203.213C21.3981 206.112 22.8497 209.605 23.5935 213.201C28.9173 220.996 21.6506 200.374 20.8887 197.453C23.7738 196.224 34.9263 210.158 36.9458 207.962C37.0405 207.651 35.4357 205.927 34.9488 205.743C34.6198 205.909 34.453 206.044 34.2591 205.738C35.2373 204.798 31.8068 203.61 31.4823 203.286C32.2035 202.57 27.4297 200.243 28.5882 200.279C27.6956 199.032 26.3298 197.777 24.7745 196.512C27.5334 195.981 28.7325 194.036 28.48 195.049L28.471 195.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$4e38f8e127b6b98b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 740 478",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M739.945 477.053L728.47 42.8846L403.714 51.9593L402.956 475.471L739.945 477.053Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.2766 21.5979C66.7767 20.978 65.6542 10.1027 63.8098 13.042C63.0037 14.0204 63.013 14.9796 64.0782 15.3669C61.9471 15.5508 64.6106 17.7697 63.8524 18.7063C62.4064 18.268 65.2624 21.3987 63.7729 20.7378C61.3465 32.2642 73.9329 56.5486 67.4076 27.4713C66.5426 30.2678 66.1529 27.5553 66.5698 26.3008C68.3198 28.2426 67.071 22.8154 66.4921 21.7923C66.4105 23.4442 65.2187 20.6369 66.2713 21.6025L66.2766 21.5979Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.9395 41.4791C46.9566 39.9576 37.0855 32.9328 36.1601 32.0708C33.8362 30.599 33.3907 34.0732 35.4116 34.7754C35.7436 35.0826 38.6085 36.2619 37.299 36.8864C37.7317 39.8964 42.95 40.6524 43.0937 43.1784C43.8141 42.8232 44.5739 43.7637 45.051 43.5916C44.9167 44.3313 45.8852 44.8118 45.9878 44.6391C48.3432 47.9902 51.6853 44.2447 48.0933 42.2918C48.2618 42.1735 47.6694 41.2644 46.9494 41.4798L46.9395 41.4791Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.7401 78.7976C26.3547 80.2709 24.5525 80.0579 23.772 79.3305C25.3978 78.2085 21.8092 77.9733 20.8595 78.3227C21.2268 78.4227 21.2389 79.0726 20.4717 78.9103C21.3013 77.4094 11.5803 75.4721 15.5859 79.54C15.7542 79.5615 16.0603 78.3193 16.184 78.7421C15.5038 80.5878 17.2858 79.5164 17.7456 79.443C17.5533 80.4283 18.1351 79.5794 18.1687 80.006C17.3932 81.2461 20.303 79.438 19.4595 80.6534C21.3263 83.0425 26.2528 81.1126 27.625 83.2332C29.2172 81.2103 35.7726 85.7171 33.7911 81.0187C30.8779 79.5466 28.4464 78.5866 24.7401 78.7976Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.3204 53.0348C8.98192 55.9537 15.8356 56.4071 17.4345 57.9592C19.3188 60.1099 41.9669 70.2344 36.895 63.213C30.0144 60.2067 24.9055 56.5376 16.0964 53.9487C14.6967 53.4237 10.5196 50.8717 10.3204 53.0348Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.0372 37.8984C89.2159 40.0542 85.6577 42.0527 87.4086 44.0495C90.893 47.1931 96.2939 24.8368 92.1239 24.9014C88.5433 25.4405 88.8059 36.5316 87.0372 37.8984Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$f4813b8b24b3c6ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 748 441",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 203.398L355 155V441L9.56873 430.355L0 203.398Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M748 21.7328C744.748 16.1599 748.569 6.30979 743.319 0.987671C732.702 -2.57202 730.745 18.1313 723.821 20.8202C720.67 15.5886 724.004 7.66819 720.04 2.21372C720.23 2.34607 720.84 3.03576 720.907 3.12632C710.495 -8.79968 707.039 19.2669 699.16 20.9248C695.854 15.1847 701.437 -0.377695 691.295 0.284086C684.899 0.381612 677.549 28.1973 673.856 18.7234L673.843 18.8559L673.795 18.8071C674.154 25.5572 679.825 18.0616 680.841 15.9439C672.156 32.6487 672.637 11.5552 671.749 3.89249C673.484 5.91963 672.766 11.4856 673.355 13.882C673.274 -15.3688 658.525 10.3292 651.791 20.6321C647.014 20.3813 650.476 8.48332 648.356 4.57533C648.478 5.41126 649.277 10.1411 648.491 11.0607C648.281 7.59849 648.471 0.277127 643.315 1.16182C643.844 0.0263465 646.432 1.16182 646.73 1.68428C635.931 -3.6448 634.501 19.002 626.053 20.9874C623.594 15.094 626.71 7.55679 623.269 1.75401C613.262 -9.37785 602.382 37.0094 600.546 14.3626C599.984 9.79281 601.616 1.78879 596 1.00162C596.888 1.53801 598.873 2.98004 598.764 5.22313C598.615 4.98628 598.473 4.74943 598.324 4.52652C599.848 10.4965 597.28 16.8914 599.997 22.5131C607.05 29.4165 614.143 -0.175617 621.29 2.78498C624.231 6.61635 622.124 12.9415 622.869 17.5252C622.815 17.3789 622.544 16.4316 622.496 16.3062C624.454 38.2773 638.261 6.73472 636.913 11.4369C654.264 -16.8177 637.462 39.6566 656.262 21.2173C660.693 17.3929 663.416 2.7153 669.263 4.67278C670.049 12.238 670.435 34.014 681.282 19.9285C685.367 15.2124 686.993 5.18826 693.036 3.79504C696.24 9.70927 690.854 30.3569 703.286 23.6694C703.164 23.7182 703.049 23.7739 702.92 23.8226C707.961 22.0114 713.089 -2.32819 718.374 5.00714C720.413 9.77196 716.572 23.4883 724.43 23.8993C731.307 23.3072 738.339 -6.76563 743.183 6.9019C744.064 10.162 743.671 24.568 747.986 21.7119L748 21.7328Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$523a506d2ef0ae23 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 721 465",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359.416 94.2542L274.408 67.7112L9.74577 90.2379L0.164061 457.629L312.003 464.667L359.416 94.2542Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M720.092 34.905C720.117 34.8633 720.117 34.7882 720.168 34.7299C718.688 33.996 718.519 32.1946 717.377 31.1188L717.335 31.0771C716.177 30.7101 716.489 29.5676 715.052 29.5593C715.052 29.5593 715.424 29.3757 715.432 29.3757C713.098 27.0906 707.331 21.478 707.331 21.478C707.204 21.9867 708.253 21.1027 709.31 21.2528C709.31 21.2528 709.386 21.061 709.462 21.2112C712.16 18.6175 715.196 17.625 718.646 16.3908C720.371 15.9321 720.633 11.12 717.682 13.1132C717.648 13.0798 717.572 13.0549 717.538 12.9965C716.506 14.1808 714.79 13.747 713.487 14.3641L713.437 14.3892L711.272 15.4317C710.096 15.907 708.701 16.2824 707.238 16.6493C707.28 16.6076 707.323 16.5659 707.365 16.5242C707.365 16.5242 707.517 14.2141 707.475 13.0715C707.475 13.0715 708.955 11.2368 708.464 9.97753C709.302 8.50139 712.278 5.27381 709.572 4.35644C708.684 4.35644 707.991 3.59755 707.686 5.00697C707.636 4.99863 707.568 5.01529 707.5 4.99027C707.34 6.44973 705.589 7.48388 705.107 8.86828L705.09 8.92671C705.209 10.111 704.279 11.2785 704.27 11.2785C703.83 12.3626 703.255 13.5469 702.646 14.7811C702.393 14.114 702.114 13.5219 701.835 13.0966C700.82 12.0124 701.251 -2.799 697.497 0.470187C697.674 3.26401 698.57 6.17454 697.843 8.65978C697.488 8.8516 698.029 9.84404 698.469 10.653C698.435 11.6788 698.224 12.2292 698.165 13.697C696.304 12.371 688.186 5.65753 688.685 10.1777C689.556 10.6364 690.19 11.1617 690.647 12.2292C691.07 12.6879 694.799 14.7562 694.917 15.2733C694.672 15.9905 699.078 16.5659 697.294 17.0996C697.556 17.6667 697.911 18.2089 698.325 18.7343C696.397 18.9344 694.089 19.4931 692.879 20.2187C692.668 20.5773 684.973 21.061 682.182 22.8374C680.516 23.7631 679.045 24.2218 680.778 25.6146C681.404 25.1142 683.755 25.8314 683.704 25.1725C684.279 25.4061 688.169 23.9382 688.6 24.1884C688.812 24.522 691.873 22.754 691.509 23.588C693.632 24.1801 696.22 23.6963 698.909 23.0208C697.843 24.6888 696.795 27.0656 696.659 28.5417C695.746 30.4349 693.336 34.6215 692.566 37.1902C691.467 39.0583 691.848 39.2083 693.235 40.1674L693.26 40.1925C693.547 40.3843 693.226 40.1924 694.317 40.2341C694.207 40.134 694.046 39.7004 693.835 39.7755C693.979 39.4836 695.636 39.0665 694.943 38.6746C694.917 38.6162 696 37.7989 696.11 36.9149C697.074 33.7625 699.382 32.1696 701.09 28.5751C701.048 28.9504 703.923 36.0142 703.788 39.5336C703.577 41.2682 707.839 43.8536 707.221 39.984C707.272 39.9673 707.314 39.9006 707.39 39.8922C706.705 38.2993 707.61 36.6564 707.255 35.0384L707.238 34.9718C706.469 33.9877 707.357 33.1704 706.139 32.3698C706.139 32.3698 706.553 32.4114 706.562 32.4197C706.02 30.1263 705.682 27.3242 705.175 24.8139C706.993 26.4401 708.591 28.1915 709.251 30.118L709.335 29.9929C709.335 30.0513 709.462 30.0929 709.352 30.2264C710.883 30.5433 711.407 31.1771 712.515 31.6025C712.515 31.6025 713.699 33.7124 715.077 33.7875L717.174 36.7147C718.079 38.2242 722.959 37.3569 720.126 34.9384L720.092 34.905Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("b97hj", function(module, exports) {
$parcel$export(module.exports, "ProductModalCarousel", function () { return $67177947439a6edd$export$4bbc33d47571e3e6; });
/* modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ggSCt = parcelRequire("ggSCt");

var $eY3N6 = parcelRequire("eY3N6");

var $b2wEL = parcelRequire("b2wEL");
const $67177947439a6edd$var$LeftArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _1e0216lh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "65",
            height: "64",
            viewBox: "0 0 65 64",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M56.6172 32C56.6172 18.6667 45.9505 8 32.6172 8C19.2838 8 8.61718 18.6667 8.61719 32C8.61719 45.3333 19.2839 56 32.6172 56C45.9505 56 56.6172 45.3333 56.6172 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M35.2842 20.2667L39.0176 24.0001L31.0176 32.0001L39.0176 40.0001L35.2842 43.7334L23.5509 32.0001L35.2842 20.2667Z",
                    fill: "white"
                })
            ]
        })
    });
const $67177947439a6edd$var$RightArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _rjxp16lh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            fill: "#none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M8 32C8 45.3333 18.6667 56 32 56C45.3333 56 56 45.3333 56 32C56 18.6667 45.3333 8 32 8C18.6667 8 8 18.6667 8 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M29.3329 43.7333L25.5996 39.9999L33.5996 31.9999L25.5996 23.9999L29.3329 20.2666L41.0663 31.9999L29.3329 43.7333Z",
                    fill: "white"
                })
            ]
        })
    });
const $67177947439a6edd$var$settings = {
    prevArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($67177947439a6edd$var$LeftArrow, {}),
    nextArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($67177947439a6edd$var$RightArrow, {})
};
const $67177947439a6edd$export$4bbc33d47571e3e6 = ({ children: children })=>{
    const { modalIndex: modalIndex } = (0, $b2wEL.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const beforeChange = (currentSlide, nextSlide)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-carousel-slide-button-clicked",
                section: "hero-section",
                slide: currentSlide,
                nextSlide: nextSlide
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _liwcglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_j6fg1txw _19moidpf _1vqqkfja _m8oxidpf _bzd2kfja _3otn1r31 _1d59glyw _r3kx1o36 _1u351txw _6aywidpf _1imc1wqb _1plyidpf _1k001wqb _1xnx1ule _qzmo15vq",
                "_1bsb1w8u"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                ...$67177947439a6edd$var$settings,
                initialSlide: modalIndex,
                beforeChange: beforeChange,
                children: children
            })
        })
    });
};
const $67177947439a6edd$var$modalBackgroundStyles = null;
const $67177947439a6edd$var$sliderParent = null;
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $67177947439a6edd$var$slickStyle = null;
const $67177947439a6edd$var$arrowButton = null;
const $67177947439a6edd$var$buttonLeft = null;
const $67177947439a6edd$var$buttonRight = null;

});

parcelRegister("ktT4l", function(module, exports) {
$parcel$export(module.exports, "ProductModalCard", function () { return $9d005f3db5353a9a$export$91f997500fc720d5; });
/* product-modal-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $h6Fsc = parcelRequire("h6Fsc");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $28AH4 = parcelRequire("28AH4");

var $b2wEL = parcelRequire("b2wEL");
const $9d005f3db5353a9a$export$91f997500fc720d5 = ({ eyebrow: eyebrow, title: title, description: description, iconCollection: iconCollection, image: image, BackgroundImage: BackgroundImage, ctaLink: ctaLink, label: label, personaData: personaData })=>{
    const intl = (0, $8e22h.default)();
    const { closeModal: closeModal } = (0, $b2wEL.useHeroState)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const handleClick = ()=>{
        // Set team/persona in local storage for various uses later in funnel
        setAnchorLocalStorage(personaData);
    };
    const buttonText = intl.formatMessage({
        id: "jira-product-tour.hero-modal-cta-btn.btn-text",
        defaultMessage: "Get started"
    });
    const iconTitle = intl.formatMessage({
        id: "jira-product-tour.hero-modal-icon-title.title-text",
        defaultMessage: "Collaborate with these features"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2rkoqslr _11q71q2x _16qsaa27 _1bahesu3 _1bsb1w8u _4t3i1w8u _1ikw1us8 _6ru51osq _79ty1sxn _1p9vu67f _tnru1vuk _1rfm1w8u"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1vuk _1bsb1vuk _kqswstnw _1e0c1txw _1bah1h6o _1rfm1vuk _tnru1vuk"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BackgroundImage, {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: image,
                        alt: "",
                        className: (0, $2jatx.default)([
                            "_c71l1w8u _p12f12it _kqswstnw _1rkb1w8u _123r1w8u"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsbr60k _2rkoqslr _bfhku67f _zzrm1osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ca0qidpf _u5f3d6z3 _n3tdidpf _19bvd6z3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            onClick: closeModal,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bahesu3 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _19itglyw _1pfh7vkz _80omtlke"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                                size: "medium",
                                label: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_syaz1x0p _ect41qje _1wybdlk8 _k48p1nn1 _vwz4f6fq _1dyzt94y _1p1dangw _1q511skh _1cqs1crf _1bys7vkz"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_syaz1x0p _ect41qje _1wybzwfg _k48p1fw0 _vwz410mc _1pfh14y2 _1cqs1tcg _1bysvpzd"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfh1gkc _1cqs7vkz _1bys1tcg _srwz7vkz"
                            ]),
                            children: description
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3it94y _bfhk1sas _1pfhzwfg",
                                "_liwcglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhzwfg _6rthrdoj _syazr3uz _1wyb7vkz _k48p1nn1 _vwz41tcg _1bsbn8ye",
                                "_liwcglyw"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _zulpftgi _81641y44"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_syazr3uz _1wybdlk8 _k48p1nn1 _vwz4gktf"
                                            ]),
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1q51zwfg _1u2q7vkz _xlt17vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                intentType: "button",
                                containerId: "jira-product-tour-overview-hero-modal-" + personaData.team,
                                productKey: "jira-software.ondemand",
                                edition: "free",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                    onClick: handleClick,
                                    href: ctaLink,
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    dataEventProps: {
                                        "data-product-key": "jira",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "heroSection",
                                        "data-label": "get-started",
                                        "data-label-english": "Get Started",
                                        "data-track-event": `jira-pt.hero-modal-${label}.get-started`
                                    },
                                    children: buttonText
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $9d005f3db5353a9a$var$modalStyles = null;
const $9d005f3db5353a9a$var$modalImageStyles = null;
const $9d005f3db5353a9a$var$imageStyles = null;
const $9d005f3db5353a9a$var$backgroundStyles = null;
const $9d005f3db5353a9a$var$modalContentStyles = null;
const $9d005f3db5353a9a$var$textSpaceStyles = null;
const $9d005f3db5353a9a$var$closeModalButtonStyles = null;
const $9d005f3db5353a9a$var$eyebrowStyles = null;
const $9d005f3db5353a9a$var$titleStyles = null;
const $9d005f3db5353a9a$var$descriptionStyles = null;
const $9d005f3db5353a9a$var$seporatorStyles = null;
const $9d005f3db5353a9a$var$iconTitleStyles = null;
const $9d005f3db5353a9a$var$iconDescriptionStyles = null;
const $9d005f3db5353a9a$var$iconContainerStyles = null;
const $9d005f3db5353a9a$var$iconAndTextStyles = null;
const $9d005f3db5353a9a$var$iconStyles = null;
const $9d005f3db5353a9a$var$buttonSpaceStyles = null;
const $9d005f3db5353a9a$var$displayNoneBelowLg = null;

});



parcelRegister("iE2db", function(module, exports) {
$parcel$export(module.exports, "LoggedOutHeader", function () { return $c37ad61dcaa246c6$export$e0bdd3a7befb091b; });
/* logged-out-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $c37ad61dcaa246c6$export$e0bdd3a7befb091b = ({ subHeading: subHeading, testGWP7617Experiment: testGWP7617Experiment })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const gwp7617Experiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp7617JiraShortTermAiInfusionExperiment);
    const useGWP7617Experiment = testGWP7617Experiment || gwp7617Experiment !== undefined && gwp7617Experiment.type === "enrolled" && gwp7617Experiment.value === "test";
    const mainHeading = useGWP7617Experiment ? formatMessage({
        id: "jira-product-tour.hero-header.header-text-gwp-7617",
        defaultMessage: "<strong>Focus <br></br>on <span>outcomes,</span></strong><br></br> not admin"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text
            }),
        span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: text
            }),
        br: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
    }) : formatMessage({
        id: "jira-product-tour.hero-header.header-text",
        defaultMessage: "<strong>Great outcomes</strong> start with <em>Jira</em>"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                children: text
            })
    });
    const displayedSubheading = useGWP7617Experiment ? formatMessage({
        id: "jira-product-tour.hero-header.subheading-text-gwp-7617",
        defaultMessage: "AI-powered project management that removes the work around work."
    }) : subHeading;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-out-header",
        className: (0, $2jatx.default)([
            "_1e0c11p5 _p12f1y37 _6a6zv2br _jzgezwfg _1rkbko4j _zzsz1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _1wyb14no _k48p4jg8 _1bsb1osq _vwz41gnr _2h8iglyw _60qa8n31 _1fxr1ule _cq6t4jg8 _a7ooh2mm _143949fr _mnurmgnk _c9e31f51 _1vd9b3bt _h9bzgktf _1x9td439 _odmg12gs _1sphmyb0 _1sbfstnw _vr2wh2mm _15lnbx14 _vvh0mgnk _12ng1f51 _140bb3bt _18ywo7ao _1mt1yjp0 _tedggktf _h3qd1y44 _1yl3stnw _erwr1nu9 _15701ule _flz0ckbl _17q314id _fz891k4y _k5t0yjp0 _xsmr1h6o"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4bzd7 _k48p1nn1 _1wybgktf _vwz41f4h _syaz1hlo _so7d7vkz _19q11ou6 _xsmr1h6o"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: displayedSubheading
            })
        ]
    });
};
const $c37ad61dcaa246c6$var$sectionStyles = null;
const $c37ad61dcaa246c6$var$subheadingStyles = null;
const $c37ad61dcaa246c6$var$mainHeadingStyles = null;

});

parcelRegister("dmP4q", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraProductTourAccountCreation", function () { return $1e25437fc90af75b$export$f1c46015a9dcb031; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $32ARy = parcelRequire("32ARy");

var $5tLnS = parcelRequire("5tLnS");
const $1e25437fc90af75b$export$f1c46015a9dcb031 = ()=>{
    const getContinueUrl = (0, $5tLnS.useDeferSiteNamingContinueUrl)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
        Login: null,
        Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
            providers: {
                google: "Google"
            }
        }),
        getContinueUrl: getContinueUrl
    });
};

});


parcelRegister("1i0Tw", function(module, exports) {
$parcel$export(module.exports, "NoJiraHeroSection", function () { return $5f71690abca8e56f$export$68338f1ab5428abb; });
/* no-jira-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6V1n4 = parcelRequire("6V1n4");

var $7chqp = parcelRequire("7chqp");

var $6Sktx = parcelRequire("6Sktx");

var $bQjAr = parcelRequire("bQjAr");
const $5f71690abca8e56f$export$68338f1ab5428abb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "logged-out-no-jira-product-tour-hero",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Sktx.Header), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7chqp.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6V1n4.LogoBanner), {})
        ]
    });
};
$5f71690abca8e56f$export$68338f1ab5428abb.displayName = "NoJiraHeroSection";
const $5f71690abca8e56f$var$heroStyles = null;

});
parcelRegister("6Sktx", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return $32314b1200b84dcf$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $asbmK = parcelRequire("asbmK");

var $gfjAv = parcelRequire("gfjAv");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $32314b1200b84dcf$export$8b251419efc915eb = ()=>{
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: "/try/cloud/signup?bundle=jira-software"
    });
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const subHeading = formatMessage({
        id: "jira-product-tour.hero-header.sub-header-text",
        defaultMessage: "The only project management tool you need to plan and track work across every team."
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.hero-header.button-text",
        defaultMessage: "Get Jira free"
    });
    const mainHeading = formatMessage({
        id: "jira-product-tour.hero-header.header-text",
        defaultMessage: "<strong>Great outcomes</strong> start with <em>Jira</em>"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                className: (0, $2jatx.default)([
                    "_k48p8n31 _1e0c1ule _181n1nu9"
                ]),
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                className: (0, $2jatx.default)([
                    "_zg8l4jg8 _kqswh2mm _3p6m49fr _1v5vmgnk _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                ]),
                children: text
            })
    });
    const handleClick = (e)=>{
        if (openCrossFlow) openCrossFlow(e);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _6a6z1h6o _1q51vbgk _jzgezwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _1wyb14no _k48p4jg8 _vwz41gnr _19pkidpf _2hwx1crf _otyr1crf _18u01crf _y3gn1h6o _flz0ckbl _fz891k4y"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4bzd7 _k48p1nn1 _1wybgktf _vwz41f4h _y3gn1h6o _syaz1hlo _ca0qidpf _u5f39by0 _n3td1ylp _19bv9by0 _so7d7vkz _19q11ou6 _tl28idpf _axwix19p _1hwc1ylp _sp8tx19p"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: subHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                intentType: "button",
                containerId: "heroSection",
                productKey: "jira-software.ondemand",
                edition: "free",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                    onClick: handleClick,
                    href: (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=jira-software"),
                    variant: "primary",
                    size: "large",
                    color: "blue",
                    dataEventProps: {
                        "data-product-key": "jira",
                        "data-event": "clicked",
                        "data-event-component": "button",
                        "data-event-container": "heroSection",
                        "data-label": "get-jira-free",
                        "data-label-english": "Get Jira Free",
                        "data-track-event": "jira-pt.hero-cta.get-jira-free"
                    },
                    children: buttonText
                })
            })
        ]
    });
};
const $32314b1200b84dcf$var$sectionStyles = null;
const $32314b1200b84dcf$var$subheadingStyles = null;
const $32314b1200b84dcf$var$mainHeadingStyles = null;
const $32314b1200b84dcf$var$mainHeadingStrongStyles = null;
const $32314b1200b84dcf$var$mainHeadingEmStyles = null;

});


parcelRegister("6PlQY", function(module, exports) {
$parcel$export(module.exports, "TestimonialSection", function () { return $f83d961845a629ac$export$1b0efcc7c1027c88; });
/* testimonial.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $9MZ6h = parcelRequire("9MZ6h");

var $AR1pQ = parcelRequire("AR1pQ");
const $f83d961845a629ac$export$f756e64b0cdd0c57 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mezj1u1b _bna710mc _1egfglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3t76qr31nd0pyj71cs0562wxs6agxl02.webp",
                alt: ""
            }
        })
    });
};
const $f83d961845a629ac$export$1b0efcc7c1027c88 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-testimonial-button-clicked",
                section: "testimonial-section"
            }
        }).fire();
    };
    const header = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.header-text",
        defaultMessage: "For teams big & small"
    });
    const subtitle = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.subtitle-text",
        defaultMessage: "Hear from start-ups & large enterprises that prefer Atlassian"
    });
    const ctaTextOld = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.cta-text",
        defaultMessage: "See more customer stories"
    });
    const ctaTextAi = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.cta-text-ai",
        defaultMessage: "See how Roblox boosts collaboration with AI"
    });
    const ctaText = useGWP7617Gate ? ctaTextAi : ctaTextOld;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mkrz16pp _11q71hlo _1e0c1txw _4cvr1h6o _1bah1h6o _ca0q19bv _u5f3idpf _n3td53f4 _19bvidpf _2tde53f4 _1a87idpf _uwpc53f4 _3r7oidpf _1kmx19bv _1ggmidpf _1ykzuuw1 _1maeidpf"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _4cvr1y6m _a64k1w81 _79ty1bp4 _1np61h6o _1yytidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _zulp19bv"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($f83d961845a629ac$export$f756e64b0cdd0c57, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_liwc1txw _79ty1bp4 _105s1h6o _1rkb1i94 _1kmxidpf _1ggm10yn _1ykzidpf _1mae10yn"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1i7q1ogy _liwc1txw _79ty1bp4 _m80d1h6o _1yyt10yn _1p1d8vuz _1rkbjwe6"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _ect41pz4 _k48p1fw0 _vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _fz891ylp _1ol9ckbl _flz0ckbl _1lzo1ylp _1cqs1ul9"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                        },
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _syaz1f62 _ect4bzd7 _1wyb7vkz _k48p1nn1 _vwz41tcg"
                                        ]),
                                        style: {
                                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1pfhzwfg _1rwyidpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                            href: (0, $jQ0cd.useLocalizedHref)("/customers/roblox"),
                                            onClick: handleClick,
                                            className: (0, $2jatx.default)([
                                                "_syazcqtm"
                                            ]),
                                            style: {
                                                "--_r4erkq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue400"))
                                            },
                                            children: [
                                                ctaText,
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9MZ6h.ArrowRight), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $AR1pQ.TestimonialCard), {
                    image: "https://dam-cdn.atl.orangelogic.com/AssetLink/thb1c563p4m28u32ri7fe867jx24dxpl.webp",
                    quote: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.quote-text",
                        defaultMessage: "Before, our team saw Atlassian as individual tools...Now, [features & integrations] like Jira macros & Smart Links have really been pivotal in collaboration, productivity, & discoverability."
                    }),
                    name: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.name-text",
                        defaultMessage: "Joe Cotant"
                    }),
                    title: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.job-title-text",
                        defaultMessage: "Senior Technical Program Manager, Roblox"
                    })
                })
            ]
        })
    });
};
$f83d961845a629ac$export$1b0efcc7c1027c88.displayName = "TestimonialSection";
const $f83d961845a629ac$var$sectionContainer = null;
const $f83d961845a629ac$var$testimonialContainer = null;
const $f83d961845a629ac$var$testimonialContentContainer = null;
const $f83d961845a629ac$var$leftContainer = null;
const $f83d961845a629ac$var$contentStyles = null;
const $f83d961845a629ac$var$headingStyles = null;
const $f83d961845a629ac$var$subtitleStyles = null;
const $f83d961845a629ac$var$linkStyles = null;
const $f83d961845a629ac$var$anchorStyles = null;
const $f83d961845a629ac$var$starStyles = null;

});
parcelRegister("9MZ6h", function(module, exports) {
$parcel$export(module.exports, "ArrowRight", function () { return $3c710196451a00e5$export$acad20503ad73ac1; });

var $7VQPk = parcelRequire("7VQPk");
const $3c710196451a00e5$export$acad20503ad73ac1 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});

parcelRegister("AR1pQ", function(module, exports) {
$parcel$export(module.exports, "TestimonialCard", function () { return $755c5031f1e223bd$export$a34a40ba0fc7f13f; });
/* testimonial-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $755c5031f1e223bd$export$e4a9ef29ffd77837 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsb9by0 _rjxp4l2f _152t1vmu _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8egyb3e0hgar3nj26we824nso1lfh124.webp",
                alt: "",
                width: 78,
                height: 47
            }
        })
    });
};
const $755c5031f1e223bd$export$8c97d8ed71074b34 = ({ image: image })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ahbq1hnc _1pfh1hnc _mezj1w6l _bna75k64"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: image,
                alt: "",
                width: 255,
                height: 238
            }
        })
    });
};
const $755c5031f1e223bd$export$a34a40ba0fc7f13f = ({ image: image, quote: quote, name: name, title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($755c5031f1e223bd$export$e4a9ef29ffd77837, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _syazr3uz _p12f1kqb _85i510yn _bfhku67f _2rko1uj0 _1gde1bp4 _1rkbjwe6"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($755c5031f1e223bd$export$8c97d8ed71074b34, {
                        image: image
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb17ek _ahbq16gx _1qoxo7ao _suga1txw _1gde1bp4 _nssp1h6o _chtu1ou6 _v7361ou6"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1k92 _syaz1yn5 _ect41td8 _1rkbncxg _q5ug1pa9 _7tld182x _14adidpf _4uroidpf _1cqsgktf _1bys1f4h _18ghnl7k _chtu1ou6",
                                    "quote"
                                ]),
                                children: [
                                    "\u201C",
                                    quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                                className: (0, $2jatx.default)([
                                    "_1bsb19n7 _4t3it94y _syaz9sh9 _19pk7vkz _2hwxidpf _otyridpf _18u0idpf _1rfmajfg"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wybqgp8 _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "name"
                                ]),
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybgktf _ui901hgu _62c41qje _1jw81nn1 _1bys1tcg _1rkb1rr2",
                                    "title"
                                ]),
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $755c5031f1e223bd$var$cardContainerStyles = null;
const $755c5031f1e223bd$var$testimonialQuoteImageStyles = null;
const $755c5031f1e223bd$var$testimonialQuotesSectionStyles = null;
const $755c5031f1e223bd$var$customerImagePictureStyles = null;
const $755c5031f1e223bd$var$quoteContainerStyles = null;
const $755c5031f1e223bd$var$quoteStyles = null;
const $755c5031f1e223bd$var$hrContainerStyles = null;
const $755c5031f1e223bd$var$nameStyles = null;
const $755c5031f1e223bd$var$titleStyles = null;

});




//# sourceMappingURL=index.1031e8b1.js.map
